/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';
import cx from 'classnames';
import $ from 'jquery';
import {
  Loader, Statistic, Label, Icon, Segment, Dimmer, Pagination, Checkbox, Input, Modal, Header
} from 'semantic-ui-react';
import Update from 'immutability-helper';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { Droppable, Draggable, DragDropContext } from 'react-beautiful-dnd';
import FileSaver from 'file-saver';
import { v4 as uuidv4 } from 'uuid';
import { withTranslation } from 'react-i18next';
import WithRouter from '../Extensions/WithRouter';
import ContentsHeaderWithResultAll from '../SubHeader/ContentsHeaderWithResultAll';
import ComponentSummaryView from '../SmallPanel/ComponentSummaryView';
import Footer from '../Footer/Footer';
import ComponentProjectCard from '../Card/ComponentProjectCard';
import api from '../../api';
import normalBookmarkImg from '../../images/components/content_projects_list/bookmarkBtn (Project) (normal).png';
import activeBookmarkImg from '../../images/components/content_projects_list/bookmarkBtn (Project) (active).png';
import expandToggle from '../../images/components/content_projects/expandsmallIcon.png';
import CompareModal from '../Modal/CompareModal';
import LeakageListModal from '../Modal/LeakageListModal';
import MiniPieChart from '../Extensions/MiniPieChart';
import downIcon from '../../images/components/content_wide_card/headerSorting (down).png';
import upIcon from '../../images/components/content_wide_card/headerSorting (up).png';
import expandBtn from '../../images/components/content_file/expand-btn.svg';
import quickScan from '../../images/components/content_project_card/quickScan.png';
import moreBtn from '../../images/components/content_project_card/newRisk.png';
import compareBtn from '../../images/icons/compare.png';
import deleteIcon from '../../images/components/content_project_card/delete-icon.svg';
import exportIcon from '../../images/components/content_project_card/export-icon.svg';
import moveFileIcon from '../../images/components/content_project_card/move-file-icon.svg';
import ScanInfoModal from '../Modal/ScanInfoModal';
import ExportModal from '../Modal/ExportModal';
import SPDXDocumentGenerator from '../SBOM/SPDXDocumentGenerator';
import CycloneDXDocumentGenerator from '../SBOM/CycloneDXDocumentGenerator';
import NISModal from '../NISTools/NISModal';
import VexGenerator from '../SBOM/VexGenerator';
import MoveFileModal from '../Modal/MoveFileModal';
import DeleteModal from '../Modal/DeleteModal';
import CBOMGenerator from '../SBOM/CBOMGenerator';
import { findComponentProjectSortValue, findComponentProjectSortColumn } from '../Extensions/MatchedSortValue';
import {
  //SCANS_LABEL_ARCHIVE,
  REPORT_EXTENSION_CSV,
  REPORT_EXTENSION_EXCEL,
  REPORT_EXTENSION_JSON,
} from '../../constants/reports';
import WarningModal from '../Modal/WarningModal';
import ProjectExportModal from '../Modal/ProjectExportModal';

class ComponentProjectList extends Component {
  constructor(props) {
    super(props);
    this.modalAction = null;
    this.modalBody = null;
    this.modalHeader = null;
    this.modalSubBody = null;
    const { state } = this.props;
    this.state = {
      pageSize: state.user.page_limit,
      currentPage: 1,
      totalPage: '',
      uploadedLimit: 7,
      isLoading: false,
      isMoreLoading: false,
      selectedId: '',
      error: null,
      hasMoreProjectList: true,
      isOpenCompare: false,
      isCompareLoading: false,
      isSetLeft: false,
      isSetRight: false,
      isOpenCPM: false,
      isOpenMLK: false,
      selectedUid: null,
      selectedName: null,
      selectedLeftData: {},
      selectedRightData: {},
      compareResult: {},
      projectList: [],
      searchKeyword: '',
      sortColumn: 'uploaded',
      activeIndex: [],
      startDate: '',
      endDate: '',
      componentMin: '',
      componentMax: '',
      filter: [],
      bookmarkProjectVersionId: null,
      bookmarkProjectId: null,
      radioValue: 'udtime_any',
      isScroll: false,
      isSort: false,
      sortValue: 7,
      isOpenMSI: false,
      isOpenMFM: false,
      isOpenAlert: false,
      modalExportIsOpen: false,
      currentData: {},
      scanInfoUid: '',
      isDownloadingReport: false,
      isMovingFile: false,
      viewMode: state.user.view_mode,
      isSelectable: false,
      isCheckAll: false,
      checkValues: [],
      isResizeHeaeder: false,
      activePage: '',
      pdfElement: '',
      isRenderProjectView: false,
      isOpenWarnModal: false,
      mainText: null,
      subText: null,
      isOpenMPE: false,
      isDownloadingProjectReport: false,
      isLoadingProjectReport: false,
      selectedProjectName: '',
      selectedProjectId: '',
      isOpenAlertModal: false,
      toExport: '',
      activeMenuIndex: '',
      isOpenMCX: false,
      reportId: '',
      isShowSbom: false,
      isOpenMCD: false,
      isOpenMNA: false,
      isOpenMVX: false,
      isModalError: false,
      totalCount: 0,
      isOpenMCB: false,
      bookmarkProjectName: null,
      bookmarkProjectVersionName: null,
    };
    this.toggleRow = this.toggleRow.bind(this);
    this.handleMoreData = this.handleMoreData.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleVerticalOnScroll = this.handleVerticalOnScroll.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.clearValue = this.clearValue.bind(this);
    this.clearRadioValue = this.clearRadioValue.bind(this);
    this.clearAllValue = this.clearAllValue.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.handleChangeSorting = this.handleChangeSorting.bind(this);
    this.handleFilterData = this.handleFilterData.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleProjectBookmarkChange = this.handleProjectBookmarkChange.bind(this);
    this.handleCardVersionBookmarkChange = this.handleCardVersionBookmarkChange.bind(this);
    this.handleCardBookmarkChange = this.handleCardBookmarkChange.bind(this);
    this.setCompareItem = this.setCompareItem.bind(this);
    this.handleCompareChange = this.handleCompareChange.bind(this);
    this.handleCPMClose = this.handleCPMClose.bind(this);
    this.handleLeakageList = this.handleLeakageList.bind(this);
    this.handleMLKClose = this.handleMLKClose.bind(this);
    this.removeCurrentFile = this.removeCurrentFile.bind(this);
    this.deletedCallback = this.deletedCallback.bind(this);
    this.updateFilePath = this.updateFilePath.bind(this);
    this.updateHistoryStatus = this.updateHistoryStatus.bind(this);
    this.toggleViewMode = this.toggleViewMode.bind(this);
    this.toggleBookmarkOnList = this.toggleBookmarkOnList.bind(this);
    this.toggleVersionBookmarkOnList = this.toggleVersionBookmarkOnList.bind(this);
    this.setCompareItemOnList = this.setCompareItemOnList.bind(this);
    this.handleListSortingChange = this.handleListSortingChange.bind(this);
    this.handleDeleteOnList = this.handleDeleteOnList.bind(this);
    this.handleExport = this.handleExport.bind(this);
    this.handleInfoItem = this.handleInfoItem.bind(this);
    this.handleMoreMenu = this.handleMoreMenu.bind(this);
    this.handleMove = this.handleMove.bind(this);
    this.handlePaginationChange = this.handlePaginationChange.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleMSIClose = this.handleMSIClose.bind(this);
    this.handleChangeView = this.handleChangeView.bind(this);
    this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
    this.toggleSelectMode = this.toggleSelectMode.bind(this);
    this.handleCheckAllChange = this.handleCheckAllChange.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.handleDeleteChange = this.handleDeleteChange.bind(this);
    this.handleMultipleDeleteCallback = this.handleMultipleDeleteCallback.bind(this);
    this.handleInputActivePageChange = this.handleInputActivePageChange.bind(this);
    this.handleActivePageChange = this.handleActivePageChange.bind(this);
    this.handleSpdx = this.handleSpdx.bind(this);
    this.handleCycloneDx = this.handleCycloneDx.bind(this);
    this.handleVexBom = this.handleVexBom.bind(this);
    this.handleNIASbom = this.handleNIASbom.bind(this);
    this.handleSlideToggle = this.handleSlideToggle.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.createElementWithCanvas = this.createElementWithCanvas.bind(this);
    this.generatePdfCallback = this.generatePdfCallback.bind(this);
    this.setFileMove = this.setFileMove.bind(this);
    this.downloadReport = this.downloadReport.bind(this);
    this.onUpdatePredicate = this.onUpdatePredicate.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.closeExportModal = this.closeExportModal.bind(this);
    this.closeMoveFileModal = this.closeMoveFileModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.downloadProjectReport = this.downloadProjectReport.bind(this);
    this.initLoading = this.initLoading.bind(this);
    this.handleCBOM = this.handleCBOM.bind(this);
  }

  componentDidMount() {
    const { state, location, navigateType } = this.props;
    state.user.initPrecisionLevel();
    state.pages.setAction(navigateType);
    document.addEventListener('mousedown', this.handleClickOutside);
    window.addEventListener('scroll', this.handleVerticalOnScroll);
    window.addEventListener('resize', this.onUpdatePredicate);

    this.onUpdatePredicate();
    const $contentsHeader = $('.contents_header');
    const $contents = $('.contents');
    const $window = $(window);
    let { top } = $contentsHeader.offset();
    $window.on('scroll.contents_header', () => {
      if (!$contentsHeader.hasClass('fixed')) {
        top = $contentsHeader.offset().top;
      }
      if (top - $window.scrollTop() < 140) {
        $contentsHeader.addClass('fixed');
        $contents.css('padding-top', '45px');
      } else {
        $contentsHeader.removeClass('fixed');
        $contents.css('padding-top', 0);
      }
    });

    if (localStorage.getItem('bookmarkObj') || state.report.isActiveNav) {
      this.handleBookmarkLogic();
    } else if (navigateType === 'POP') {
      const {
        pathname,
      } = location;
      const scrollData = toJS(state.pages.scrollData);

      if (scrollData[pathname] || scrollData[pathname] === 0) {
        this.updateHistoryStatus();
      } else {
        this.initHistoryStatus();
      }
    } else {
      this.getComProjectList();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { state } = this.props;
    const {
      isOpenCompare, isScroll, viewMode, pageSize, isSelectable
    } = this.state;

    const userStore = { ...state.user };

    const isNavActivated = state.report.isActiveNav;
    const wasNavActivated = prevProps.state.report.isActiveNav;

    if (isNavActivated && !wasNavActivated) {
      this.handleBookmarkLogic();
    }

    if (viewMode === '' && userStore.view_mode !== '') {
      this.setState({
        viewMode: userStore.view_mode,
      });
    }

    if (pageSize === '' && userStore.page_limit !== '') {
      this.setState({
        pageSize: userStore.page_limit,
      });
    }

    if (prevState.isScroll !== isScroll && isScroll) {
      this.updateAutoScroll();
    }

    if (isOpenCompare !== prevState.isOpenCompare && isOpenCompare) {
      this.setState({
        activeMenuIndex: '',
        isShowSbom: false,
      });
    }

    if (isSelectable !== prevState.isSelectable) {
      this.onUpdatePredicate();
    }

    if (viewMode !== prevState.viewMode) {
      this.onUpdatePredicate();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleVerticalOnScroll);
    document.removeEventListener('mousedown', this.handleClickOutside);
    window.removeEventListener('resize', this.onUpdatePredicate);
    if (localStorage.getItem('bookmarkObj')) {
      localStorage.removeItem('bookmarkObj');
    }
  }

  handleBookmarkLogic = () => {
    const { state, location } = this.props;

    let targetIds = {};
    let projectName = null;
    let projectVersionName = null;
    let bookmarkFileName = null;
    let isFromStorage = false;

    const queryParams = new URLSearchParams(location.search);
    const paramProjectId = queryParams.get('project_id');
    const paramVersionId = queryParams.get('project_version_id');
    const paramFileId = queryParams.get('uploaded_file_id');
    const storedBookmark = localStorage.getItem('bookmarkObj');

    if (paramProjectId || paramVersionId || paramFileId) {
      targetIds = {
        project_id: paramProjectId,
        project_version_id: paramVersionId,
        uploaded_file_id: paramFileId,
      };

      if (storedBookmark) {
        const parsedObj = JSON.parse(storedBookmark);
        isFromStorage = true;

        if (parsedObj.targetObject === 'project') {
          projectName = parsedObj.name;
        } else if (parsedObj.targetObject === 'project_version') {
          projectName = parsedObj.projectName;
          projectVersionName = parsedObj.name;
        } else if (parsedObj.targetObject === 'report') {
          projectName = parsedObj.projectName;
          bookmarkFileName = parsedObj.name;
        }
      }
    } else if (storedBookmark) {
      const parsedObj = JSON.parse(storedBookmark);
      targetIds = parsedObj.targetId;
      isFromStorage = true;

      if (parsedObj.targetObject === 'project') {
        projectName = parsedObj.name;
      } else if (parsedObj.targetObject === 'project_version') {
        projectName = parsedObj.projectName;
        projectVersionName = parsedObj.name;
      } else if (parsedObj.targetObject === 'report') {
        projectName = parsedObj.projectName;
        bookmarkFileName = parsedObj.name;
      }
    } else if (state.report.isActiveNav) {
      targetIds = toJS(state.report.targetNavBookmark);
      projectName = toJS(state.report.projectName);
      projectVersionName = toJS(state.report.projectVersionName);
      bookmarkFileName = toJS(state.report.bookmarkFileName);
    }

    if (
      targetIds
      && (targetIds.project_id
        || targetIds.project_version_id
        || targetIds.uploaded_file_id)
    ) {
      this.updateBookmarkfilter(
        targetIds,
        isFromStorage,
        projectName,
        projectVersionName,
        bookmarkFileName
      );
    }
  };

  handleActivePageChange(e) {
    const { totalPage, pageSize, activePage } = this.state;
    if (e.key === 'Enter') {
      if (activePage > totalPage) {
        return;
      }
      this.setState({
        //searchKeyword: '',
        projectList: [],
        activeIndex: [],
        currentPage: activePage,
        checkValues: [],
        isCheckAll: false,
      }, () => {
        this.getComProjectList(activePage, pageSize);
      });
    }
  }

  handleInputActivePageChange(e, { value }) {
    const { totalPage } = this.state;
    if (totalPage < value) {
      return;
    }

    this.setState({
      activePage: value,
    });
  }

  handleMultipleDeleteCallback() {
    this.setState({
      isOpenAlert: false,
      isSelectable: false,
      projectList: [],
    }, () => {
      this.getComProjectList();
    });
  }

  handleListSortingChange = (e) => {
    const { sortValue, isSort } = this.state;
    if (e.currentTarget.dataset.id !== sortValue) {
      const currentColumn = findComponentProjectSortColumn(false, e.currentTarget.dataset.id);
      this.setState(
        {
          sortValue: e.currentTarget.dataset.id,
          isSort: false,
          sortColumn: currentColumn,
          projectList: [],
          activeIndex: [],
        },
        () => {
          this.getComProjectList();
        }
      );
    } else {
      const currentColumn = findComponentProjectSortColumn(!isSort, e.currentTarget.dataset.id);
      this.setState(
        {
          sortValue: e.currentTarget.dataset.id,
          isSort: !isSort,
          sortColumn: currentColumn,
          projectList: [],
          activeIndex: [],
        },
        () => {
          this.getComProjectList();
        }
      );
    }
  };

  handlePageSizeChange(value) {
    this.setState(
      {
        pageSize: value,
        currentPage: 1,
        projectList: [],
        activeIndex: [],
      },
      () => {
        this.getComProjectList();
      }
    );
  }

  handleMLKClose() {
    this.setState({
      selectedUid: null,
      selectedName: null,
      isOpenMLK: false,
    });
  }

  handleLeakageList = (uploadedFileId, fileName) => {
    this.setState({
      selectedUid: uploadedFileId,
      selectedName: fileName,
      isOpenMLK: true,
    });
  };

  handleClick = (idReport) => {
    const { navigate } = this.props;
    const { isSelectable } = this.state;
    if (isSelectable) {
      return;
    }
    this.setPreviousData(idReport);
    navigate(`/results/component/binary/${idReport}`);
  };

  handleVerticalOnScroll() {
    const {
      getComProjectList,
      state: {
        error, isLoading, hasMoreProjectList, projectList, viewMode, pageSize
      },
    } = this;

    if (!projectList || projectList.length === 0) {
      return null;
    }

    if (viewMode === 'list') {
      return;
    }

    const scrollHeight = Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight
    );
    const scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    const { clientHeight } = document.documentElement;
    const pageNo = Math.ceil(projectList.length / pageSize);
    if (error || isLoading || !hasMoreProjectList) {
      return;
    }
    const px = Math.ceil(scrollHeight) - Math.ceil(scrollTop + clientHeight);
    const isNextPage = px > -2 && px < 1;

    if (Math.ceil(scrollTop + clientHeight) === Math.ceil(scrollHeight) || isNextPage) {
      this.setState({
        isCheckAll: false,
      }, () => {
        getComProjectList(pageNo + 1, pageSize);
      });
    }
  }

  handleMoreData = (pid) => {
    this.getComProjectDetail(pid);
  };

  handleChange(value) {
    this.setState(
      {
        searchKeyword: value,
        projectList: [],
        activeIndex: [],
      },
      () => {
        this.getComProjectList();
      }
    );
  }

  handleChangeSorting(value) {
    const obj = findComponentProjectSortValue(value);
    this.setState(
      {
        sortColumn: value,
        isSort: obj.isSort,
        sortValue: obj.sortValue,
        projectList: [],
        activeIndex: [],
      },
      () => {
        this.getComProjectList();
      }
    );
  }

  handleFilterData(value) {
    this.setState(
      {
        projectList: [],
        activeIndex: [],
        componentMin: value.component_min,
        componentMax: value.component_max,
        startDate: value.uploaded_start,
        endDate: value.uploaded_end,
        filter: value.filter,
        radioValue: value.radio,
        checkValues: [],
        isCheckAll: false,
      },
      () => {
        this.getComProjectList();
      }
    );
  }

  handleProjectBookmarkChange(e, pid) {
    const projectId = pid;
    const { state, t } = this.props;
    const { projectList } = this.state;
    const updatedIndex = projectList.findIndex((item) => {
      return item.pid === projectId;
    });
    api
      .toggleBookmark(
        {
          project_id: projectId,
          view_point: 'component',
        }
      )
      .then((response) => {
        const res = response.response;
        if (updatedIndex !== 'undefined') {
          this.setState({
            projectList: Update(projectList, {
              [updatedIndex]: {
                isBookmark: { $set: res.is_bookmark },
              },
            }),
            //isBookmarkLoading: false,
          }, () => {
            state.report.setActiveBookMark();
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          error: t('modal.error.error_load'),
          //isBookmarkLoading: false,
        });
      });
  }

  handleCardVersionBookmarkChange = (cardIndex, projectVersionId, isBookmark) => {
    const { projectList } = this.state;
    const { state } = this.props;
    const updatedIndex = projectList[cardIndex].upLoaded.findIndex((item) => {
      return item.project_version_id === projectVersionId;
    });
    this.setState({
      projectList: Update(projectList, {
        [cardIndex]: {
          upLoaded: {
            [updatedIndex]: {
              project_version_is_bookmark: { $set: isBookmark },
            },
          },
        },
      }),
      //isBookmarkLoading: false,
    }, () => {
      state.report.setActiveBookMark();
    });
  };

  handleCardBookmarkChange = (cardIndex, uploadedFileId, isBookmark) => {
    const { projectList } = this.state;
    const { state } = this.props;
    const updatedIndex = projectList[cardIndex].upLoaded.findIndex((item) => {
      return item.uploaded_file_id === uploadedFileId;
    });

    this.setState({
      projectList: Update(projectList, {
        [cardIndex]: {
          upLoaded: {
            [updatedIndex]: {
              is_bookmark: { $set: isBookmark },
            },
          },
        },
      }),
      //isBookmarkLoading: false,
    }, () => {
      state.report.setActiveBookMark();
    });
  };

  handleCompareChange() {
    const { selectedLeftData, selectedRightData } = this.state;

    const obj = {
      source_id: selectedLeftData.uid,
      target_id: selectedRightData.uid,
      base_limit: 25,
    };

    this.setState({
      isCompareLoading: true,
      isOpenCPM: true,
      isOpenCompare: false,
    }, () => {
      api
        .setCompareData(obj)
        .then((response) => {
          const data = response.response;
          this.setState({
            isCompareLoading: false,
            compareResult: data,
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isCompareLoading: false,
          });
        });
    });
  }

  handleCPMClose() {
    this.setState({
      isOpenCPM: false,
      compareResult: {},
    });
  }

  handleDeleteOnList = (obj) => {
    this.setState({
      isOpenAlert: true,
      currentData: obj,
    });
  };

  handleExport = (obj) => {
    this.setState({
      modalExportIsOpen: true,
      currentData: obj,
    });
  };

  handleSpdx = (uid, value) => {
    this.setState({
      isOpenMCX: true,
      reportId: uid,
      uploadedFileName: value,
    });
  };

  handleCycloneDx = (uid) => {
    this.setState({
      isOpenMCD: true,
      reportId: uid,
    });
  };

  handleVexBom = (uid) => {
    this.setState({
      isOpenMVX: true,
      reportId: uid,
    });
  };

  handleNIASbom = (uid) => {
    this.setState({
      isOpenMNA: true,
      reportId: uid,
    });
  };

  handleInfoItem = (uid) => {
    this.setState({
      scanInfoUid: uid,
      isOpenMSI: true,
    });
  };

  handleCBOM(rowData) {
    const { t } = this.props;
    const { has_crypto, uploaded_file_id, name } = rowData;

    if (has_crypto) {
      this.setState({
        isOpenMCB: true,
        reportId: uploaded_file_id,
        uploadedFileName: name,
      });
    } else {
      this.modalAction = t('modal.title.notice');
      this.modalBody = t('modal.message.no_crypto_data');
      this.modalHeader = null;

      this.setState({
        isOpenAlertModal: true,
      });
    }
  }

  handleMoreMenu = (value) => {
    const { activeMenuIndex } = this.state;
    if (activeMenuIndex === value) {
      this.setState({
        activeMenuIndex: '',
        isShowSbom: false,
      });
    } else {
      this.setState({
        activeMenuIndex: value,
        isShowSbom: false,
      });
    }
  };

  handleMove = (obj) => {
    this.setState({
      isOpenMFM: true,
      currentData: obj,
    });
  };

  handlePaginationChange = (e, { activePage }) => {
    const { pageSize } = this.state;
    this.setState({
      //searchKeyword: '',
      projectList: [],
      activeIndex: [],
      currentPage: activePage,
      checkValues: [],
      isCheckAll: false,
      activePage,
    }, () => {
      this.getComProjectList(activePage, pageSize);
    });
  };

  handleClickOutside(e) {
    const { activeMenuIndex } = this.state;
    const container = $('.list_view .more_menu');

    if (container && container.has(e.target).length === 0) {
      if (activeMenuIndex !== '') {
        this.setState({
          activeMenuIndex: '',
          isShowSbom: false,
        });
      }
    }
  }

  handleSlideToggle = () => {
    const { isShowSbom } = this.state;
    this.setState({
      isShowSbom: !isShowSbom,
    });
  };

  handleMSIClose() {
    this.setState({
      scanInfoUid: '',
      isOpenMSI: false,
    });
  }

  handleProjectExport = (obj) => {
    this.setState({
      selectedProjectName: obj.projectName,
      selectedProjectId: obj.pid,
      isOpenMPE: true,
      isLoadingProjectReport: true,
    });
  };

  handleSearchChange(value) {
    this.setState({
      searchKeyword: value,
    });
  }

  onDragEnd = (result) => {
    const {
      source, //start
      destination, //end
      draggableId,
    } = result;

    if (!destination) {
      return null;
    }

    if (source.droppableId === destination.droppableId) {
      //reorder
      return null;
    }

    this.move(
      this.getList(draggableId),
      //destination,
      //source
    );
  };

  onUpdatePredicate() {
    const { isSelectable, viewMode } = this.state;
    //viewMode
    if (isSelectable) {
      this.setState({
        isResizeHeaeder: window.innerWidth < 1555,
      });
    } else if (viewMode === 'list') {
      this.setState({
        isResizeHeaeder: window.innerWidth < 1430,
      });
    } else {
      this.setState({
        isResizeHeaeder: window.innerWidth < 1380,
      });
    }
  }

  setFileMove(obj, id) {
    this.setState({
      isMovingFile: true,
    }, () => {
      api.setFileMove({
        selected_project_id: obj.selectedProject.id,
        selected_project_version_id: obj.selectedProjectVersion.id,
      }, id)
        .then(() => {
          this.setState({
            isMovingFile: false,
            isOpenMFM: false,
          }, () => {
            this.updateFilePath(obj, id);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    });
  }

  toggleRow = (e, index) => {
    const { activeIndex } = this.state;
    let newState;

    if (e.target.classList.length === 0) {
      if (e.target.classList.value === '' && e.target.className !== '') {
        return;
      }
    }

    if (e.target.classList.length > 0) {
      if (e.target.classList.value === 'normal' || e.target.classList.value === 'active' || e.target.className === 'fake') {
        return;
      }
    }

    if (activeIndex.indexOf(index) > -1) {
      newState = activeIndex.filter((i) => {
        return i !== index;
      });
    } else {
      newState = [...activeIndex, index];
    }
    this.setState({ activeIndex: newState });
  };

  toggleViewMode = (value) => {
    this.setState({
      viewMode: value,
      currentPage: 1,
      searchKeyword: '',
      projectList: [],
      activeIndex: [],
      isSelectable: false,
      checkValues: [],
      isCheckAll: false,
    }, () => {
      this.getComProjectList();
    });
  };

  toggleSelectMode = (value) => {
    this.setState({
      isSelectable: value,
      checkValues: [],
      isCheckAll: false,
    });
  };

  toggleBookmarkOnList = (uid, index) => {
    api.toggleBookmark(
      {
        uploaded_file_id: uid,
        view_point: 'component',
      }
    )
      .then((response) => {
        const res = response.response;
        this.handleCardBookmarkChange(index, uid, res.is_bookmark);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  toggleVersionBookmarkOnList = (index, pvid) => {
    const projectVersionId = pvid;
    api.toggleBookmark(
      {
        project_version_id: projectVersionId,
        view_point: 'component',
      }
    )
      .then((response) => {
        const res = response.response;
        this.handleCardVersionBookmarkChange(index, projectVersionId, res.is_bookmark);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  initHistoryStatus = () => {
    const { location, state } = this.props;
    const { pathname } = location;

    state.pages.initScrollData(pathname);
    state.pages.initStatusData();
    setTimeout(() => {
      this.getComProjectList();
    }, 500);
  };

  getComProjectList = (pageNo, limit) => {
    let filterData;
    const {
      radioValue, projectList, pageSize, filter
    } = this.state;
    const { state, t } = this.props;
    const userStore = { ...state.user };
    const page = pageNo || 1;
    let perPage = limit || pageSize;
    if (perPage === '') {
      perPage = userStore.page_limit || localStorage.getItem('page_limit');
    }
    if (filter.length !== 0) {
      let i = 0;
      for (i; i < filter.length; i++) {
        if (i === 0) {
          filterData = filter[i];
        } else {
          filterData = `${filterData},${filter[i]}`;
        }
      }
      filterData = `${filterData},${radioValue}`;
    } else {
      filterData = `${radioValue}`;
    }
    this.setState(
      {
        isLoading: true,
      },
      () => {
        api
          .getComProjectList(
            {
              search: this.state.searchKeyword,
              uploaded_start: this.state.startDate,
              uploaded_end: this.state.endDate,
              component_min: this.state.componentMin,
              component_max: this.state.componentMax,
              filter: filterData,
              page,
              limit: perPage,
              upload_limit: this.state.uploadedLimit,
              order: this.state.sortColumn,
              bookmark_project_id: this.state.bookmarkProjectId,
              bookmark_project_version_id: this.state.bookmarkProjectVersionId,
              ...this.props.location.query
            }
          )
          .then((response) => {
            if (this.state.projectList.length !== 0 && response.pagination.current === 1) {
              return false;
            }
            const nextComProjectList = response.response.map((item) => {
              return {
                pid: item.project_id,
                projectName: item.name,
                versionCount: item.version_count,
                uploadedCount: item.uploaded_count,
                isQuickScan: item.is_quick_scan,
                isBookmark: item.is_bookmark,
                componentCount: item.component_count,
                owner: item.owner,
                upLoaded: item.uploaded,
                isNextData: item.next,
                mostFound: item.most_found,
                mostVuln: item.most_vulnerable,
                cardCurrentPage: 1,
              };
            });

            this.setState({
              currentPage: response.pagination.current,
              pageSize: response.pagination.per_page,
              totalPage: response.pagination.pages,
              totalCount: response.pagination.count,
              hasMoreProjectList: response.pagination.next !== null,
              isLoading: false,
              projectList: [...projectList, ...nextComProjectList],
            });
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              error: t('modal.error.error_load'),
              isLoading: false,
            });
          });
      }
    );
  };

  getComProjectDetail = (pid) => {
    const perPage = this.state.uploadedLimit;
    const { projectList } = this.state;
    const { t } = this.props;
    const projectId = pid;
    const updatedIndex = this.state.projectList.findIndex((item) => {
      return item.pid === pid;
    });
    this.setState(
      {
        isMoreLoading: true,
        selectedId: pid,
      },
      () => {
        api
          .getComProjectDetail(
            {
              search: this.state.searchKeyword,
              page: Math.ceil(this.state.projectList[updatedIndex].upLoaded.length / 7) + 1,
              limit: perPage,
            },
            projectId
          )
          .then((response) => {
            if (updatedIndex !== 'undefined') {
              this.setState({
                projectList: Update(projectList, {
                  [updatedIndex]: {
                    upLoaded: {
                      $push: response.response,
                    },
                    isNextData: {
                      $set: response.pagination.next !== null,
                    },
                    cardCurrentPage: {
                      $set: Math.ceil(projectList[updatedIndex].upLoaded.length / 7) + 1,
                    },
                  },
                }),
                isMoreLoading: false,
                selectedId: '',
              });
            }
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              error: t('modal.error.error_load'),
              isMoreLoading: false,
              selectedId: '',
            });
          });
      }
    );
  };

  getList = (id) => {
    const { projectList } = this.state;
    let idxs;

    projectList.map((subArray, index) => {
      return subArray.upLoaded.map((item, idx) => {
        if (item.uploaded_file_id.toString() === id) {
          idxs = {
            i: index,
            j: idx,
          };
          return idxs;
        }
        return null;
      });
    });

    const projectName = projectList[idxs.i].upLoaded.filter((item) => {
      if (item.project_version_name) {
        return item.project_version_id === projectList[idxs.i].upLoaded[idxs.j].project_version_id;
      }
      return null;
    });

    const draggableData = {
      uid: projectList[idxs.i].upLoaded[idxs.j].uploaded_file_id,
      pid: projectList[idxs.i].upLoaded[idxs.j].project_id,
      pvi: projectList[idxs.i].upLoaded[idxs.j].project_version_id,
      name: projectList[idxs.i].upLoaded[idxs.j].name,
      projectName: projectList[idxs.i].projectName,
      projectVersionName: projectName[0].project_version_name,
      uploadedDate: projectList[idxs.i].upLoaded[idxs.j].uploaded_at,
      owner: projectList[idxs.i].upLoaded[idxs.j].owner,
      precisionLevel: projectList[idxs.i].upLoaded[idxs.j].precision_level,
    };
    return draggableData;
  };

  setPreviousData = () => {
    const {
      pathname,
    } = this.props.location;

    const {
      searchKeyword,
      projectList,
      activeIndex,
      filter,
      radioValue,
      sortColumn,
      currentPage,
      viewMode,
      pageSize,
      totalCount,
    } = this.state;

    const status = {
      searchKeyword,
      projectList,
      activeIndex,
      filter,
      radioValue,
      sortColumn,
      viewMode,
      pageSize,
      totalCount,
    };

    this.props.state.pages.setScrollData(pathname, document.documentElement.scrollTop, currentPage, pageSize);
    this.props.state.pages.setStatusData(status);
  };

  setCompareItem = (obj) => {
    const { projectList } = this.state;

    const selectedArray = projectList.filter((item) => {
      return item.pid === obj.project_id;
    });

    const selectedCard = selectedArray[0].upLoaded.filter((item) => {
      return item.project_version_id === obj.project_version_id;
    });

    const data = {
      uid: obj.uploaded_file_id,
      pid: obj.project_id,
      pvi: obj.project_version_id,
      name: obj.name,
      projectName: selectedArray[0].projectName,
      projectVersionName: selectedCard[0].project_version_name,
      uploadedDate: obj.uploaded_at,
      owner: obj.owner,
      precisionLevel: obj.precision_level,
    };

    this.setState({
      isOpenCompare: true,
      isSetLeft: true,
      isSetRight: false,
      selectedLeftData: data,
      selectedRightData: {},
    });
  };

  setCompareItemOnList = (obj) => {
    const { projectList } = this.state;

    const selectedArray = projectList.filter((item) => {
      return item.pid === obj.project_id;
    });

    const selectedCard = selectedArray[0].upLoaded.filter((item) => {
      return item.project_version_id === obj.project_version_id;
    });

    const data = {
      uid: obj.uploaded_file_id,
      pid: obj.project_id,
      pvi: obj.project_version_id,
      name: obj.name,
      projectName: selectedArray[0].projectName,
      projectVersionName: selectedCard[0].project_version_name,
      uploadedDate: obj.uploaded_at,
      owner: obj.owner,
      precisionLevel: obj.precision_level,
    };

    this.setState({
      selectedRightData: data,
      isSetRight: true,
    });
  };

  updateFilePath = (obj, id) => {
    const { projectList } = this.state;

    const updatedIndex = projectList.findIndex((item) => {
      return item.project_id === obj.selectedProject.id;
    });

    const splicedIndex = projectList.findIndex((item) => {
      return item.project_id === obj.rowData.project_id;
    });

    if (!projectList[splicedIndex]) {
      this.setState({
        projectList: [],
        activeIndex: [],
      }, () => {
        this.getComProjectList();
      });
      return null;
    }
    const splicedCardIndex = projectList[splicedIndex].uploaded.findIndex((item) => {
      return item.uploaded_file_id === id;
    });

    if (updatedIndex === -1 || splicedIndex === -1 || splicedCardIndex === -1) {
      this.setState({
        projectList: [],
        activeIndex: [],
      }, () => {
        this.getComProjectList();
      });
      return null;
    }

    this.setState({
      projectList: Update(projectList, {
        [updatedIndex]: {
          uploaded: { $unshift: projectList[splicedIndex].uploaded[splicedCardIndex] },
        },
        [splicedIndex]: {
          uploaded: { $splice: [splicedCardIndex, 1] },
        },
      }),
    });
  };

  updateHistoryStatus = async () => {
    const { state } = this.props;
    const statusObj = toJS(state.pages.statusObj);

    const array = statusObj.projectList.slice().map((item) => {
      return {
        pid: item.pid,
        projectName: item.projectName,
        versionCount: item.versionCount,
        uploadedCount: item.uploadedCount,
        isQuickScan: item.isQuickScan,
        isBookmark: item.isBookmark,
        componentCount: item.componentCount,
        owner: item.owner,
        upLoaded: item.upLoaded.slice(),
        isNextData: item.isNextData,
        mostFound: item.mostFound.slice(),
        mostVuln: item.mostVuln.slice(),
        cardCurrentPage: item.cardCurrentPage,
      };
    });

    this.setState({
      searchKeyword: statusObj.searchKeyword,
      filter: statusObj.filter.slice(),
      activeIndex: statusObj.activeIndex.slice(),
      radioValue: statusObj.radioValue,
      sortColumn: statusObj.sortColumn,
      viewMode: statusObj.viewMode,
      pageSize: statusObj.pageSize,
      projectList: array,
      totalCount: statusObj.totalCount,
      isScroll: true,
    });
  };

  updateAutoScroll = () => {
    const { state, location } = this.props;
    const {
      pathname,
    } = location;
    const scrollData = toJS(state.pages.scrollData);

    this.setState({
      isScroll: false,
    }, () => {
      setTimeout(window.scrollTo({ left: 0, top: scrollData[pathname].offset }));
    });
  };

  createElementWithCanvas = () => {
    //const { view_mode } = this.props.state.user;
    const { projectList, viewMode } = this.state;
    const { t } = this.props;
    //pdfElement
    const contentElem = document.querySelector('.content');
    if (contentElem) {
      const wrapper = contentElem.closest('.container');
      const clonedObject = wrapper.cloneNode(true);
      const containerEl = clonedObject.closest('.container');
      containerEl.style.paddingTop = 0;
      //containerEl.style.display = 'none';

      if (clonedObject) {
        const resultHeaderEl = clonedObject.getElementsByClassName('result_header');
        const resultHeaderInnerEl = clonedObject.getElementsByClassName('result_header_inner');
        const contentsSummaryInnerEl = clonedObject.getElementsByClassName('contents_summary_inner');
        const contentsEl = clonedObject.getElementsByClassName('contents');
        const utilWrapEl = clonedObject.getElementsByClassName('util_wrap');
        const moveTopEl = clonedObject.getElementsByClassName('move_to_top');
        const pageEle = clonedObject.getElementsByClassName('clar_pagination');
        const footerEl = clonedObject.getElementsByClassName('footer');
        const expandProject = clonedObject.getElementsByClassName('content_projects expand');
        const expandTableEl = clonedObject.getElementsByClassName('wide_card_box expand');
        //const chartEl = clonedObject.getElementsByClassName('chartjs-render-monitor');
        const tableEl = clonedObject.getElementsByClassName('content_projects');
        const listViewTableEl = clonedObject.getElementsByClassName('wide_card_box');

        if (viewMode === 'list' && expandTableEl.length !== 0) {
          return this.setState({
            isOpenWarnModal: true,
            mainText: t('modal.message.clraity_report_main_warn'),
            subText: t('modal.message.clarity_reporty_sub_warn'),
          });
        }

        if (resultHeaderEl.length !== 0) {
          resultHeaderEl[0].style.top = 0;
        }

        if (resultHeaderInnerEl.length !== 0) {
          resultHeaderInnerEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (contentsSummaryInnerEl.length !== 0) {
          contentsSummaryInnerEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (contentsEl.length !== 0) {
          contentsEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (utilWrapEl.length !== 0) {
          while (utilWrapEl.length > 0) {
            utilWrapEl[0].parentNode.removeChild(utilWrapEl[0]);
          }
        }

        if (moveTopEl.length !== 0) {
          while (moveTopEl.length > 0) {
            moveTopEl[0].parentNode.removeChild(moveTopEl[0]);
          }
        }

        if (pageEle.length !== 0) {
          while (pageEle.length > 0) {
            pageEle[0].parentNode.removeChild(pageEle[0]);
          }
        }

        if (footerEl.length !== 0) {
          while (footerEl.length > 0) {
            footerEl[0].parentNode.removeChild(footerEl[0]);
          }
        }
        //expandProject
        //projectList = [{upLoaded: [], }];

        if (viewMode === 'card') {
          if (expandProject.length > 0) {
            const obj = projectList.map((item, index) => {
              if (tableEl[index].classList.contains('expand')) {
                //item.upLoaded.length 7개 = 1줄 = table + 3
                const cardsCount = item.upLoaded.length;
                const addTableHeightCount = Math.ceil(cardsCount / 7) * 4;
                return {
                  index,
                  count: addTableHeightCount + 1,
                };
              }
              return { index, count: 1 };
            });

            let i = 0;
            let count = 0;
            for (i; i < obj.length; i++) {
              if (i === 0) {
                count = obj[i].count;
                if (obj[i + 1] && obj[i + 1].count) {
                  if (obj[i].count + obj[i + 1].count > 8) {
                    tableEl[i].classList.add('page-break');
                    count = 0;
                  }
                }
              } else {
                const pageBreakEl = clonedObject.getElementsByClassName('page-break');
                count += obj[i].count;
                if (pageBreakEl.length === 0) {
                  if (count > 8) {
                    tableEl[i].classList.add('page-break');
                    count = 0;
                  }
                  if (obj[i + 1] && obj[i + 1].count) {
                    if (count + obj[i + 1].count > 8) {
                      tableEl[i].classList.add('page-break');
                      count = 0;
                    }
                  }
                } else {
                  if (count > 8) {
                    tableEl[i].classList.add('page-break');
                    count = 0;
                  }
                  if (obj[i + 1] && obj[i + 1].count) {
                    if (count + obj[i + 1].count > 8) {
                      tableEl[i].classList.add('page-break');
                      count = 0;
                    }
                  }
                }
              }
            }
          } else {
            let i = 0;
            for (i; i < tableEl.length; i++) {
              if ((i === 7 && tableEl.length > 8) || (i > 7 && (i - 7) % 9 === 0)) {
                tableEl[i].classList.add('page-break');
              }
            }
          }
        }
        if (viewMode === 'list') {
          if (expandTableEl.length === 0) {
            let i = 0;
            for (i; i < listViewTableEl.length; i++) {
              if ((i === 13 && listViewTableEl.length > 13) || (i > 13 && (i - 13) % 16 === 0)) {
                listViewTableEl[i].classList.add('page-break');
              }
            }
          }
        }
      }

      document.body.appendChild(clonedObject);

      this.setState({
        pdfElement: clonedObject,
        isRenderProjectView: true,
      });
    }
  };

  generatePdfCallback = () => {
    const { pdfElement } = this.state;

    document.body.removeChild(pdfElement);
    this.setState({
      pdfElement: '',
      isRenderProjectView: false,
    });
  };

  move = (source) => {
    this.setState({
      selectedRightData: source,
      isSetRight: true,
    });
  };

  generateToken = (length) => {
    let i = 0;
    let result = '';
    const timeStamp = new Date();
    const components = [
      timeStamp.getYear(),
      timeStamp.getMonth(),
      timeStamp.getDate(),
      timeStamp.getHours(),
      timeStamp.getMinutes(),
      timeStamp.getSeconds(),
      timeStamp.getMilliseconds(),
    ];
    const id = components.join('');
    const charactersLength = id.length;

    for (i; i < length; i++) {
      result += id.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  };

  handleChangeView = (uid, string) => {
    const { navigate } = this.props;
    const { isSelectable } = this.state;

    if (isSelectable) {
      return;
    }
    this.setPreviousData(uid);
    if (string.indexOf('component') > -1) {
      navigate(`/results/component/binary/${uid}`);
    } else if (string.indexOf('security') > -1) {
      navigate(`/results/security/binary/${uid}`);
    } else if (string.indexOf('license') > -1) {
      navigate(`/results/license/binary/${uid}`);
    } else if (string.indexOf('policy') > -1) {
      navigate(`/results/policy/project/${uid}`);
    }
  };

  handleCheckAllChange = () => {
    const { isCheckAll, projectList, activeIndex } = this.state;
    const newState = [];

    if (isCheckAll) {
      this.setState({
        isCheckAll: false,
        checkValues: [],
      });
    } else {
      const activeList = projectList.filter((item, index) => {
        return activeIndex.indexOf(index) > -1;
      });

      const num = activeList.length;
      let i = 0;
      for (i; i < num; i++) {
        let j = 0;
        for (j; j < activeList[i].upLoaded.length; j++) {
          if (activeList[i].upLoaded[j].has_manage_permission) {
            newState.push(activeList[i].upLoaded[j].uploaded_file_id);
          }
        }
      }

      const unique = newState.reduce((a, b) => {
        if (a.indexOf(b) < 0) {
          a.push(b);
        }
        return a;
      }, []);
      this.setState({
        isCheckAll: true,
        checkValues: unique,
      });
    }
  };

  handleCheckChange = (e, { value }) => {
    const { checkValues, projectList, activeIndex } = this.state;
    let newState;
    if (checkValues.indexOf(value) > -1) {
      newState = checkValues.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...checkValues, value];
    }

    const activeList = projectList.filter((item) => {
      return activeIndex.indexOf(item.pid) > -1;
    });

    let i = 0;
    activeList.map((item) => {
      return item.upLoaded.map((file) => {
        if (file.has_manage_permission) {
          return i++;
        }
        return null;
      });
    });

    if (newState.length !== 0 && newState.length !== i) {
      this.setState({
        checkValues: newState,
        isCheckAll: false,
      });
    } else {
      this.setState({
        checkValues: newState,
      });
    }
  };

  handleDeleteChange = () => {
    const { checkValues } = this.state;

    if (checkValues.length === 0) {
      this.setState({
        isOpenWarnModal: true,
      });
    } else {
      this.setState({
        isOpenAlert: true,
      });
    }
  };

  updateBookmarkfilter = (
    targetIds,
    isFromStorage,
    projectName,
    projectVersionName
  ) => {
    const { state } = this.props;

    if (isFromStorage) {
      localStorage.removeItem('bookmarkObj');
    }

    state.report.completeNavBookmark();

    this.setState(
      {
        searchKeyword: '',
        projectList: [],
        activeIndex:
          targetIds.project_version_id || targetIds.project_id ? [0] : [],

        bookmarkProjectId: targetIds.project_id,
        bookmarkProjectVersionId: targetIds.project_version_id || null,
        bookmarkProjectName: projectName || null,
        bookmarkProjectVersionName: projectVersionName || null,
      },
      () => {
        this.getComProjectList();
      }
    );
  };

  clearValue = (tagValue) => {
    const { filter } = this.state;
    let newState;
    if (filter.indexOf(tagValue) > -1) {
      newState = filter.filter((el) => {
        return el !== tagValue;
      });
    } else {
      newState = [];
    }
    this.setState(
      {
        projectList: [],
        activeIndex: [],
        filter: newState,
        checkValues: [],
        isCheckAll: false,
      },
      () => {
        this.getComProjectList();
      }
    );
  };

  clearRadioValue = () => {
    this.setState(
      {
        projectList: [],
        activeIndex: [],
        startDate: '',
        endDate: '',
        radioValue: 'udtime_any',
        checkValues: [],
        isCheckAll: false,
      },
      () => {
        this.getComProjectList();
      }
    );
  };

  clearBookmark = (value) => {
    const { state } = this.props;
    if (value === 'bookmarkProjectId') {
      this.setState({
        projectList: [],
        activeIndex: [],
        bookmarkProjectId: null,
        bookmarkProjectVersionId: null,
      }, () => {
        state.report.completeNavBookmark();
        this.getComProjectList();
      });
    } else if (value === 'bookmarkProjectVersionId') {
      this.setState({
        bookmarkProjectVersionId: null,
        projectList: [],
      }, () => {
        this.getComProjectList();
      });
    }
  };

  clearAllValue = () => {
    const { state } = this.props;
    this.setState(
      {
        projectList: [],
        activeIndex: [],
        filter: [],
        startDate: '',
        endDate: '',
        bookmarkProjectId: null,
        bookmarkProjectVersionId: null,
        radioValue: 'udtime_any',
        checkValues: [],
        isCheckAll: false,
      },
      () => {
        state.report.completeNavBookmark();
        this.getComProjectList();
      }
    );
  };

  initLoading() {
    this.setState({
      isLoadingProjectReport: false,
    });
  }

  closeExportModal() {
    this.setState({
      modalExportIsOpen: false,
      isOpenMPE: false,
      isDownloadingReport: false,
      toExport: '',
    });
  }

  closeMoveFileModal() {
    this.setState({
      isOpenMFM: false,
      currentData: {},
    });
  }

  closeModal() {
    this.setState({
      currentData: {},
      reportId: '',
      isOpenAlert: false,
      isOpenWarnModal: false,
      isOpenAlertModal: false,
      isDownloadingProjectReport: false,
      isOpenMCX: false,
      isOpenMCD: false,
      isOpenMVX: false,
      isOpenMNA: false,
      toExport: '',
      mainText: null,
      subText: null,
      isModalError: false,
      isOpenMCB: false,
    });
  }

  removeCurrentFile(string) {
    if (string === 'left') {
      this.setState({
        isSetLeft: false,
        selectedLeftData: {},
      });
    } else {
      this.setState({
        isSetRight: false,
        selectedRightData: {},
      });
    }
  }

  deletedCallback() {
    this.setState(
      {
        projectList: [],
        isOpenAlert: false,
        currentData: {},
        //currentUid: '',
      },
      () => {
        this.getComProjectList();
      }
    );
  }

  clearSearch() {
    this.setState(
      {
        searchKeyword: '',
        projectList: [],
        activeIndex: [],
      },
      () => {
        this.getComProjectList();
      }
    );
  }

  downloadReport(exportFormat, exportType, toExport) {
    const { t, state } = this.props;
    const { currentPrecisionLevel } = state.user;
    const { currentData } = this.state;
    const token = this.generateToken(10);
    const downloadFormatMapping = {
      [REPORT_EXTENSION_CSV]: 'csv',
      [REPORT_EXTENSION_EXCEL]: 'xlsx',
      [REPORT_EXTENSION_JSON]: 'zip',
    };
    let type;
    let url;

    if (currentPrecisionLevel) {
      type = currentPrecisionLevel;
    } else {
      type = null;
    }

    if (type) {
      url = `/1/reports/${
        currentData.uploaded_file_id
      }/export?file_format=${exportFormat}&section=${exportType}&token=${token}&precision_level=${type}&export_to=${toExport}`;
    } else {
      url = `/1/reports/${
        currentData.uploaded_file_id
      }/export?file_format=${exportFormat}&section=${exportType}&token=${token}&export_to=${toExport}`;
    }

    this.setState({
      isDownloadingReport: true,
    });

    api
      .getExportedReport(url)
      .then((res) => {
        let data;
        let confidenceLevelName;
        const blob = new Blob([res], { type: 'application/octet-stream' });
        if (currentData.precision_level === 'narrow') {
          confidenceLevelName = 'high';
        } else if (currentData.precision_level === 'broad') {
          confidenceLevelName = 'low';
        } else {
          confidenceLevelName = currentData.precision_level;
        }
        const fileName = `${currentData.name}_${confidenceLevelName}.${downloadFormatMapping[exportFormat]}`;

        this.modalAction = t('modal.title.notice');

        if (toExport === 's3') {
          data = JSON.parse(new TextDecoder().decode(res));
          const { bucket, key } = data.response;
          this.modalBody = t('modal.message.export_send_s3');
          this.modalHeader = (
            <p className="modal_list" style={{ paddingTop: '10px' }}>
              <b>{t('modal.title.bucket')}</b>
            &nbsp;
              {bucket}
            </p>
          );
          this.modalSubBody = (
            <p className="modal_list">
              <b>{t('modal.title.file_storage_path')}</b>
            &nbsp;
              {key}
            </p>
          );
        } else if (toExport === 'email') {
          data = JSON.parse(new TextDecoder().decode(res));
          const { dest_email } = data.response;
          this.modalBody = t('modal.message.export_send_email');
          this.modalHeader = t('modal.message.export_send_to_email', { email: dest_email });
          this.modalSubBody = null;
        } else if (toExport === 'local') {
          FileSaver.saveAs(blob, fileName);
          this.modalBody = t('modal.message.export_send_local');
          this.modalHeader = null;
          this.modalSubBody = null;
        }
        this.setState({
          isDownloadingReport: false,
          modalExportIsOpen: false,
          isOpenAlertModal: true,
          toExport,
        });
      })
      .catch((err) => {
        console.log(err);
        let jsonParse;
        const ArrayBufferView = Object.getPrototypeOf(Object.getPrototypeOf(new Uint8Array())).constructor;
        if (err.data instanceof ArrayBuffer || err.data instanceof ArrayBufferView) {
          jsonParse = JSON.parse(new TextDecoder().decode(err.data));
        } else {
          jsonParse = err.data;
        }
        const o = jsonParse.response;
        this.modalAction = t('modal.title.attention');

        if (!o.error) {
          this.modalBody = t('modal.error.unknow_error');
        }

        if (o.error === '422-002') { // recovery email
          this.modalBody = t('modal.error.error_422_002_export');
        }

        if (o.error === '422-365') { // license expired
          this.modalBody = t('system.message.license_expired');
        }

        if (o.error === '422-366') {
          this.modalBody = o.error_description;
        }

        if (o.error === '422-367') { // smtp error
          this.modalBody = t('modal.error.error_422_368_jira');
        }

        if (o.error === '422-791') {
          this.modalBody = t('modal.error.error_422_791_export');
        }

        this.modalHeader = null;
        this.modalSubBody = null;

        this.setState({
          isDownloadingReport: false,
          modalExportIsOpen: false,
          isOpenAlertModal: true,
        });
      });
  }

  downloadProjectReport(obj) {
    const { t } = this.props;
    const {
      selectedProjectName,
      selectedProjectId
    } = this.state;
    const toExport = obj.export_to;

    const downloadFormatMapping = {
      [REPORT_EXTENSION_CSV]: 'csv',
      [REPORT_EXTENSION_EXCEL]: 'xlsx',
      [REPORT_EXTENSION_JSON]: 'zip',
    };

    const isJsonBlob = (data) => {
      return data instanceof Blob && data.type === 'application/json';
    };

    this.setState({
      isDownloadingProjectReport: true,
    });

    api
      .postProjectExportReport(obj, selectedProjectId)
      .then(async (res) => {
        let responseJson;
        const blob = new Blob([res], { type: 'application/octet-stream' });
        const fileName = `${selectedProjectName}_${t('project.menu.overview')}.${downloadFormatMapping[obj.file_format]}`;

        this.modalBody = null;
        this.modalHeader = null;
        this.modalSubBody = null;

        if (toExport === 's3' || toExport === 'email') {
          const responseData = isJsonBlob(res) ? await (res)?.text() : res || {};
          responseJson = (typeof responseData === 'string') ? JSON.parse(responseData) : responseData;
        }

        this.modalAction = t('modal.title.notice');
        if (toExport === 's3') {
          const { bucket, key } = responseJson.response;
          this.modalBody = t('modal.message.export_send_s3');
          this.modalHeader = (
            <p className="modal_list" style={{ paddingTop: '10px' }}>
              <b>{t('modal.title.bucket')}</b>
              &nbsp;
              {bucket}
            </p>
          );
          this.modalSubBody = (
            <p className="modal_list">
              <b>{t('modal.title.file_storage_path')}</b>
              &nbsp;
              {key}
            </p>
          );
        } else if (toExport === 'email') {
          const { dest_email } = responseJson.response;
          this.modalBody = t('modal.message.export_send_email');
          this.modalHeader = t('modal.message.export_send_to_email', { email: dest_email });
          this.modalSubBody = null;
        } else if (toExport === 'local') {
          FileSaver.saveAs(blob, fileName);
          this.modalBody = t('modal.message.export_send_local');
          this.modalHeader = null;
          this.modalSubBody = null;
        }

        this.setState({
          isDownloadingProjectReport: false,
          isOpenMPE: false,
          isOpenAlertModal: true,
          toExport,
        });
      })
      .catch(async (err) => {
        console.log(err);

        const responseData = isJsonBlob(err.data) ? await (err.data)?.text() : err.data || {};
        const responseJson = (typeof responseData === 'string') ? JSON.parse(responseData) : responseData;

        const o = responseJson.response;
        this.modalAction = t('modal.title.attention');

        if (!o.error) {
          this.modalBody = t('modal.error.unknow_error');
        }

        if (o.error === '422-002') { // recovery email
          this.modalBody = t('modal.error.error_422_002_export');
        }

        if (o.error === '422-365') { // license expired
          this.modalBody = t('system.message.license_expired');
        }

        if (o.error === '422-366') {
          this.modalBody = o.error_description;
        }

        if (o.error === '422-367') { // smtp error
          this.modalBody = t('modal.error.error_422_368_jira');
        }

        if (o.error === '422-791') {
          this.modalBody = t('modal.error.error_422_791_export');
        }

        this.modalHeader = null;
        this.modalSubBody = null;

        this.setState({
          isDownloadingProjectReport: false,
          isOpenMPE: false,
          isOpenAlertModal: true,
          isModalError: true,
        });
      });
  }

  closeMenu() {
    this.setState({
      isOpenCompare: false,
    });
  }

  renderValue() {
    const { t } = this.props;
    const {
      filter, radioValue, bookmarkProjectId, bookmarkProjectVersionId, bookmarkProjectName, bookmarkProjectVersionName
    } = this.state;

    const componentFilter = filter.filter((item) => {
      return item.indexOf('security') > -1;
    });
    const uploadedDateFilter = radioValue;

    const filterObj = {
      component: componentFilter,
      datetime: uploadedDateFilter,
      bookmarkProjectId,
      bookmarkProjectVersionId,
    };

    return (
      <div>
        {filterObj.bookmarkProjectId && (
          <Label.Group>
            <span>
              <strong>{t('project.menu.project')}</strong>
            </span>
            <Label>
              {bookmarkProjectName}
              <Icon
                name="close"
                onClick={() => {
                  return this.clearBookmark('bookmarkProjectId');
                }}
              />
            </Label>
          </Label.Group>
        )}
        {filterObj.bookmarkProjectVersionId && (
          <Label.Group>
            <span>
              <strong>{t('project.menu.project_version')}</strong>
            </span>
            <Label>
              {bookmarkProjectVersionName}
              <Icon
                name="close"
                onClick={() => {
                  return this.clearBookmark('bookmarkProjectVersionId');
                }}
              />
            </Label>
          </Label.Group>
        )}
        {filterObj.component.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('project.menu.number_of_component')}</strong>
            </span>
            {filterObj.component.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_c') > -1 && 'Critical'}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}

        {filterObj.datetime.indexOf('udtime_any') === -1 && (
          <Label.Group>
            <span>
              <strong>{t('project.menu.date')}</strong>
            </span>
            <Label as="a">
              {filterObj.datetime.indexOf('udtime_p24') > -1 && t('project.menu.past_24_hours')}
              {filterObj.datetime.indexOf('udtime_pw') > -1 && t('project.menu.past_week')}
              {filterObj.datetime.indexOf('udtime_pm') > -1 && t('project.menu.past_month')}
              {filterObj.datetime.indexOf('udtime_cr') > -1
                  && `${this.state.startDate}~${this.state.endDate}`}
              <Icon
                name="close"
                onClick={() => {
                  return this.clearRadioValue();
                }}
              />
            </Label>
          </Label.Group>
        )}

        {filter.length !== 0 || radioValue.indexOf('udtime_any') === -1 || bookmarkProjectId || bookmarkProjectVersionId ? (
          <div
            className="clear_all"
            onClick={() => {
              return this.clearAllValue();
            }}
            onKeyUp={() => {
              return this.clearAllValue();
            }}
          >
            {t('project.menu.clear_all_filters')}
          </div>
        ) : null}
      </div>
    );
  }

  renderMoreBtn = (pid) => {
    const { selectedId, isMoreLoading } = this.state;

    if (isMoreLoading && selectedId === pid) {
      return (
        <div
          style={{
            display: 'block',
            height: '45px',
            position: 'absolute',
            left: '0',
            bottom: '0',
            width: '100%',
          }}
        >
          <Segment>
            <Dimmer active inverted>
              <Loader size="medium" inline="centered" />
            </Dimmer>
          </Segment>
        </div>
      );
    }
    return (
      <a
        onClick={() => {
          return this.handleMoreData(pid);
        }}
        onKeyUp={() => {
          return this.handleMoreData(pid);
        }}
        className="more_card"
      >
        <svg
          width="26px"
          height="6px"
          viewBox="0 0 26 6"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xlinkHref="{{link:1}}"
        >
          <g
            id="02.-Result"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g
              id="cards-expand"
              transform="translate(-847.000000, -1162.000000)"
              fill="#D8D8D8"
            >
              <g id="Group-3" transform="translate(400.000000, 1162.000000)">
                <g id="Group-2" transform="translate(447.000000, 0.000000)">
                  <path
                    d="M3,6 C1.34314575,6 0,4.65685425 0,3 C0,1.34314575 1.34314575,0 3,0 C4.65685425,0 6,1.34314575 6,3 C6,4.65685425 4.65685425,6 3,6 Z M13,6 C11.3431458,6 10,4.65685425 10,3 C10,1.34314575 11.3431458,0 13,0 C14.6568542,0 16,1.34314575 16,3 C16,4.65685425 14.6568542,6 13,6 Z M23,6 C21.3431458,6 20,4.65685425 20,3 C20,1.34314575 21.3431458,0 23,0 C24.6568542,0 26,1.34314575 26,3 C26,4.65685425 24.6568542,6 23,6 Z"
                    id="Combined-Shape"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
      </a>
    );
  };

  renderMoveMenu(current) {
    const { t } = this.props;
    const { has_manage_permission } = current;

    if (!has_manage_permission) {
      return (
        <a
          style={{
            cursor: 'default',
            opacity: '.45',
            color: '#dddddd',
          }}
        >
          <img src={moveFileIcon} alt="" />
          {t('project.menu.move')}
        </a>
      );
    }
    return (
      <a
        onClick={() => { return this.handleMove(current); }}
        onKeyUp={() => { return this.handleMove(current); }}
      >
        <img src={moveFileIcon} alt="" />
        {t('project.menu.move')}
      </a>
    );
  }

  render() {
    const {
      error,
      hasMoreProjectList,
      isLoading,
      projectList,
      activeIndex,
      filter,
      radioValue,
      bookmarkProjectId,
      bookmarkProjectVersionId,
      searchKeyword,
      sortColumn,
      viewMode,
      isSort,
      sortValue,
      currentPage,
      totalPage,
      scanInfoUid,
      pageSize,
      isSelectable,
      isCheckAll,
      checkValues,
      isResizeHeaeder,
      activePage,
      pdfElement,
      isOpenWarnModal,
      mainText,
      subText,
      isDownloadingProjectReport,
      isOpenMPE,
      isLoadingProjectReport,
      selectedProjectName,
      selectedProjectId,
      startDate,
      endDate,
      isOpenAlertModal,
      toExport,
      activeMenuIndex,
      isOpenMCX,
      reportId,
      isShowSbom,
      isOpenMCD,
      isOpenMNA,
      isModalError,
      uploadedFileName,
      totalCount,
      isOpenMVX,
      isOpenMCB,
    } = this.state;

    const {
      state,
      location,
      params,
      t,
      navigate
    } = this.props;

    const getListStyle = (isDraggingOver) => {
      return {
        background: isDraggingOver && '#f5f4ff',
        opacity: isDraggingOver && 0.8,
        transitionDuration: isDraggingOver && '0.001s',
        //display: 'flex',
        //padding: 8,
        //overflow: 'auto',
      };
    };

    const iconStyle = {
      width: '14px',
      height: '14px',
      color: '#969696',
      fontWeight: 'bold',
      fontSize: '12px',
      marginRight: '5px',
    };

    return (
      <div>
        <DragDropContext onDragEnd={this.onDragEnd}>
          <ContentsHeaderWithResultAll
            onChangeSearch={this.handleChange}
            onChangeSorting={this.handleChangeSorting}
            onSubmit={this.handleFilterData}
            clearSearch={this.clearSearch}
            removeCurrentFile={this.removeCurrentFile}
            filter={filter}
            radioValue={radioValue}
            searchKeyword={searchKeyword}
            sortColumn={sortColumn}
            isSetLeft={this.state.isSetLeft}
            isSetRight={this.state.isSetRight}
            selectedLeftData={this.state.selectedLeftData}
            selectedRightData={this.state.selectedRightData}
            isOpenCompare={this.state.isOpenCompare}
            handleCompareChange={this.handleCompareChange}
            closeMenu={this.closeMenu}
            viewMode={viewMode}
            toggleViewMode={this.toggleViewMode}
            pageSize={pageSize}
            handlePageSizeChange={this.handlePageSizeChange}
            isSelectable={isSelectable}
            isCheckAll={isCheckAll}
            checkValues={checkValues}
            isResizeHeaeder={isResizeHeaeder}
            toggleSelectMode={this.toggleSelectMode}
            toggleCheckChange={this.handleCheckAllChange}
            handleDeleteChange={this.handleDeleteChange}
            refElement={pdfElement}
            isRenderProjectView={this.state.isRenderProjectView}
            createElementWithCanvas={this.createElementWithCanvas}
            generatePdfCallback={this.generatePdfCallback}
            handleSearchChange={this.handleSearchChange}
            location={location}
            state={state}
            params={params}
            translate={t}
            startDate={startDate}
            endDate={endDate}
            navigate={navigate}
            totalCount={totalCount}
          />
          {
            viewMode === 'card' ? (
              <div className="content">
                {radioValue.indexOf('udtime_any') === -1 || bookmarkProjectId || bookmarkProjectVersionId ? <div className="tag_list">{this.renderValue()}</div> : null}
                <div className="content_projects_list">
                  {projectList.map((item, index) => {
                    return (
                      <div
                        className={cx(
                          'content_projects',
                          {
                            expand: activeIndex.indexOf(index) >= 0,
                          },
                          {
                            bookmark: item.isBookmark,
                          }
                        )}
                        key={`${item.pid}_${item.projectName}`}
                      >
                        {
                          item.versionCount !== 0 && item.uploadedCount !== 0 ? (
                            <div className="content_project_header">
                              <div className="content_project_header_inner">
                                <div className="content_project_name">
                                  <h2 className="name">
                                    {item.projectName}
                                    <a
                                      className="export_button"
                                      onClick={() => { return this.handleProjectExport(item); }}
                                      onKeyUp={() => { return this.handleProjectExport(item); }}
                                    >
                                      <img src={exportIcon} style={{ display: 'inline' }} alt="" />
                                    </a>
                                    <a
                                      className="bookmark_button"
                                      onClick={(e) => { return this.handleProjectBookmarkChange(e, item.pid); }}
                                      onKeyUp={(e) => { return this.handleProjectBookmarkChange(e, item.pid); }}
                                    >
                                      {
                                        item.isBookmark ? (
                                          <img className="active" role="presentation" src={activeBookmarkImg} alt="" />
                                        ) : (
                                          <img className="normal" role="presentation" src={normalBookmarkImg} alt="" />
                                        )
                                      }
                                    </a>
                                  </h2>
                                </div>
                                <div className="content_project_info">
                                  <Statistic.Group horizontal>
                                    <Statistic size="mini" horizontal>
                                      <Statistic.Value>{item.versionCount}</Statistic.Value>
                                      <Statistic.Label>{t('card.menu.versions')}</Statistic.Label>
                                    </Statistic>
                                    <Statistic size="mini" horizontal>
                                      <Statistic.Value>{item.uploadedCount}</Statistic.Value>
                                      <Statistic.Label>{t('card.menu.files')}</Statistic.Label>
                                    </Statistic>
                                  </Statistic.Group>
                                </div>
                              </div>
                              <div
                                className="summary_item_wrap hover_area"
                                onClick={(e) => {
                                  return this.toggleRow(e, index);
                                }}
                                onKeyUp={(e) => {
                                  return this.toggleRow(e, index);
                                }}
                              >
                                <ComponentSummaryView
                                  key={`${item.pid}_${item.projectName}`}
                                  file={item}
                                  translate={t}
                                />
                              </div>
                              <a
                                className="expand_toggle_button"
                                onClick={(e) => {
                                  return this.toggleRow(e, index);
                                }}
                                onKeyUp={(e) => {
                                  return this.toggleRow(e, index);
                                }}
                              >
                                <img src={expandToggle} alt="expand" />
                              </a>
                            </div>
                          ) : (
                            <div className="content_project_header">
                              <div className="content_project_header_inner">
                                <div className="content_project_name">
                                  <h2 className="name">
                                    {item.projectName}
                                    <a
                                      className="export_button"
                                      onClick={() => { return this.handleProjectExport(item); }}
                                      onKeyUp={() => { return this.handleProjectExport(item); }}
                                    >
                                      <img src={exportIcon} style={{ display: 'inline' }} alt="" />
                                    </a>
                                    <a
                                      className="bookmark_button"
                                      onClick={(e) => { return this.handleProjectBookmarkChange(e, item.pid); }}
                                      onKeyUp={(e) => { return this.handleProjectBookmarkChange(e, item.pid); }}
                                    >
                                      {
                                        item.isBookmark ? (
                                          <img className="active" role="presentation" src={activeBookmarkImg} alt="" />
                                        ) : (
                                          <img className="normal" role="presentation" src={normalBookmarkImg} alt="" />
                                        )
                                      }
                                    </a>
                                  </h2>
                                </div>
                                <div className="content_project_info">
                                  <Statistic.Group horizontal>
                                    <Statistic size="mini" horizontal>
                                      <Statistic.Value>{item.versionCount}</Statistic.Value>
                                      <Statistic.Label>{t('card.menu.versions')}</Statistic.Label>
                                    </Statistic>
                                    <Statistic size="mini" horizontal>
                                      <Statistic.Value>{item.uploadedCount}</Statistic.Value>
                                      <Statistic.Label>{t('card.menu.files')}</Statistic.Label>
                                    </Statistic>
                                  </Statistic.Group>
                                </div>
                              </div>
                              <div
                                className="summary_item_wrap hover_area"
                              >
                                <ComponentSummaryView
                                  key={`${item.pid}_${item.projectName}`}
                                  file={item}
                                  translate={t}
                                />
                              </div>
                              <a
                                className="expand_toggle_button"
                                style={{ pointerEvents: 'none' }}
                              >
                                <img src={expandToggle} alt="expand" />
                              </a>
                            </div>
                          )
                        }
                        <Droppable droppableId="droppableCard" isDropDisabled direction="horizontal">
                          {(provided, snapshot) => {
                            return (
                              <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                style={getListStyle(snapshot.isDraggingOver)}
                              >
                                {item.upLoaded.length !== 0 ? (
                                  <div className="content_project_card_wrap">
                                    {item.upLoaded.map((group, idx) => {
                                      return (
                                        <Draggable
                                          key={group.uploaded_file_id}
                                          draggableId={group.uploaded_file_id.toString()}
                                          index={idx}
                                          isDragDisabled={!this.state.isOpenCompare}
                                        >
                                          {(draggableProvided, draggableSnapshot) => {
                                            return (
                                              <ComponentProjectCard
                                                state={state}
                                                key={group.uploaded_file_id}
                                                file={group}
                                                cardIndex={index}
                                                isSelectable={isSelectable}
                                                checkValues={checkValues}
                                                clickEvent={this.handleClick}
                                                deletedCallback={this.deletedCallback}
                                                handleCardVersionBookmarkChange={this.handleCardVersionBookmarkChange}
                                                handleCardBookmarkChange={this.handleCardBookmarkChange}
                                                updateFilePath={this.updateFilePath}
                                                projectName={item.projectName}
                                                draggableProvided={draggableProvided}
                                                draggableSnapshot={draggableSnapshot}
                                                projectList={this.state.projectList}
                                                setCompareItem={this.setCompareItem}
                                                handleLeakageList={this.handleLeakageList}
                                                handleCheckChange={this.handleCheckChange}
                                                translate={t}
                                              />
                                            );
                                          }}
                                        </Draggable>
                                      );
                                    })}
                                    {provided.placeholder}
                                    {item.isNextData && (
                                      this.renderMoreBtn(item.pid)
                                    )}
                                  </div>
                                ) : null}
                              </div>
                            );
                          }}
                        </Droppable>
                      </div>
                    );
                  })}
                  {error && <div className="error_log">{error}</div>}
                  <div style={{ paddingBottom: '14px' }}>
                    <Loader active={isLoading} inline="centered" />
                  </div>
                  {!hasMoreProjectList && <Footer />}
                </div>
              </div>
            ) : (
              <div className="content">
                {filter.length !== 0 || radioValue.indexOf('udtime_any') === -1 || bookmarkProjectId || bookmarkProjectVersionId ? <div className="tag_list">{this.renderValue()}</div> : null}
                <div className="content_projects_List">
                  <div className="wide_card_wrap">
                    <div className="table_header">
                      <div className="table_header_inner">
                        <table className="wide_card_table wide_card_scope">
                          <colgroup>
                            <col style={{ width: '13%', maxWidth: '120px' }} />
                            <col style={{ width: '6%' }} />
                            <col style={{ width: '13%', maxWidth: '120px' }} />
                            <col style={{ width: '8%' }} />
                            <col style={{ width: '20%' }} />
                            <col style={{ width: '22%' }} />
                            <col style={{ width: '4.3%', maxWidth: '40px' }} />
                            <col style={{ width: '4.3%', maxWidth: '40px' }} />
                            <col style={{ width: '4.3%', maxWidth: '40px' }} />
                          </colgroup>
                          <tbody>
                            <tr>
                              <th className="tal" style={{ paddingLeft: '10px' }}>
                                <a className="sorting_button" data-id="1" onClick={this.handleListSortingChange} onKeyUp={this.handleListSortingChange}>
                                  {t('list.title.project_name')}
                                  {isSort && sortValue === '1' ? <img src={upIcon} alt="" /> : ''}
                                  {!isSort && sortValue === '1' ? <img src={downIcon} alt="" /> : ''}
                                </a>
                              </th>
                              <th className="tac">
                                <a className="sorting_button" data-id="2" onClick={this.handleListSortingChange} onKeyUp={this.handleListSortingChange}>
                                  {t('list.title.versions')}
                                  {isSort && sortValue === '2' ? <img src={upIcon} alt="" /> : ''}
                                  {!isSort && sortValue === '2' ? <img src={downIcon} alt="" /> : ''}
                                </a>
                              </th>
                              <th className="tac">
                                <a className="sorting_button" data-id="3" onClick={this.handleListSortingChange} onKeyUp={this.handleListSortingChange}>
                                  {t('list.title.files')}
                                  {isSort && sortValue === '3' ? <img src={upIcon} alt="" /> : ''}
                                  {!isSort && sortValue === '3' ? <img src={downIcon} alt="" /> : ''}
                                </a>
                              </th>
                              <th className="tac">
                                <a className="sorting_button" data-id="4" onClick={this.handleListSortingChange} onKeyUp={this.handleListSortingChange}>
                                  {t('list.title.component')}
                                  {isSort && sortValue === '4' ? <img src={upIcon} alt="" /> : ''}
                                  {!isSort && sortValue === '4' ? <img src={downIcon} alt="" /> : ''}
                                </a>
                              </th>
                              <th className="tac">
                                <a className="sorting_button" data-id="5" onClick={this.handleListSortingChange} onKeyUp={this.handleListSortingChange}>
                                  {t('list.title.most_found')}
                                  {isSort && sortValue === '5' ? <img src={upIcon} alt="" /> : ''}
                                  {!isSort && sortValue === '5' ? <img src={downIcon} alt="" /> : ''}
                                </a>
                              </th>
                              <th className="tac" colSpan="3">
                                <a className="sorting_button" data-id="6" onClick={this.handleListSortingChange} onKeyUp={this.handleListSortingChange}>
                                  {t('list.title.most_vulnerable')}
                                  {isSort && sortValue === '6' ? <img src={upIcon} alt="" /> : ''}
                                  {!isSort && sortValue === '6' ? <img src={downIcon} alt="" /> : ''}
                                </a>
                              </th>
                              <th>&nbsp;</th>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    {projectList.map((item, index) => {
                      return (
                        <div
                          className={cx(
                            'wide_card_box wide_card_type_01',
                            {
                              expand: activeIndex.indexOf(index) >= 0,
                            },
                          )}
                          key={`${item.pid}_${item.projectName}`}
                        >
                          <table
                            className="wide_card_table wide_card_item list_view component_list"
                          >
                            <colgroup>
                              <col style={{ width: '13%', maxWidth: '120px' }} />
                              <col style={{ width: '6%' }} />
                              <col style={{ width: '13%', maxWidth: '120px' }} />
                              <col style={{ width: '8%' }} />
                              <col style={{ width: '20%' }} />
                              <col style={{ width: '22%' }} />
                              <col style={{ width: '4.3%', maxWidth: '40px' }} />
                              <col style={{ width: '4.3%', maxWidth: '40px' }} />
                              <col style={{ width: '4.3%', maxWidth: '40px' }} />
                            </colgroup>
                            <tbody>
                              {
                                item.versionCount !== 0 && item.uploadedCount !== 0 ? (
                                  <tr
                                    className="first_line"
                                    onClick={(e) => {
                                      return this.toggleRow(e, index);
                                    }}
                                  >
                                    <td
                                      className="border-none tal"
                                      style={{
                                        maxWidth: '120px',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        paddingLeft: '10px',
                                      }}
                                    >
                                      <a
                                        className="export_button"
                                        onClick={() => { return this.handleProjectExport(item); }}
                                        onKeyUp={() => { return this.handleProjectExport(item); }}
                                      >
                                        <img src={exportIcon} style={{ display: 'inline' }} alt="" />
                                      </a>
                                      <a className="bookmark_button" onClick={(e) => { return this.handleProjectBookmarkChange(e, item.pid); }} onKeyUp={(e) => { return this.handleProjectBookmarkChange(e, item.pid); }}>
                                        {
                                          item.isBookmark ? (
                                            <strong className="fake">
                                              <img className="active" role="presentation" src={activeBookmarkImg} alt="" />
                                              {item.projectName}
                                            </strong>
                                          ) : (
                                            <strong className="fake">
                                              <img className="normal" role="presentation" src={normalBookmarkImg} alt="" />
                                              {item.projectName}
                                            </strong>
                                          )
                                        }
                                      </a>
                                    </td>
                                    <td className="tac border-none">{item.versionCount}</td>
                                    <td className="tac border-none">{item.uploadedCount}</td>
                                    <td className="tar border-none tac">
                                      <MiniPieChart chartData={item.componentCount} translate={t} />
                                    </td>
                                    <td className="tac border-none">
                                      <div className="list_wrap">
                                        <ul>
                                          <li className="normal">
                                            <table style={{ tableLayout: 'fixed' }}>
                                              <colgroup>
                                                <col width="" />
                                                <col width="15%" />
                                              </colgroup>
                                              <tbody>
                                                {item.mostFound
                                                  ? item.mostFound.map((entity) => {
                                                    return (
                                                      <tr key={entity.component_name.toString()}>
                                                        <td className="found">
                                                          <span className="name">
                                                            {entity.component_name}
                                                          </span>
                                                        </td>
                                                        <td className="found">{entity.uploaded_file_count}</td>
                                                      </tr>
                                                    );
                                                  })
                                                  : null}
                                              </tbody>
                                            </table>
                                          </li>
                                        </ul>
                                      </div>
                                    </td>
                                    <td className="tac border-none" colSpan="3">
                                      <div className="list_wrap">
                                        <ul>
                                          <li className="normal">
                                            <table style={{ tableLayout: 'fixed' }}>
                                              <colgroup>
                                                <col width="50%" />
                                                <col width="15%" />
                                                <col width="15%" />
                                                <col width="" />
                                              </colgroup>
                                              <tbody>
                                                {item.mostVuln
                                                  ? item.mostVuln.map((entity) => {
                                                    return (
                                                      <tr key={entity.component_name.toString()}>
                                                        <td className="found">
                                                          <span className="name">
                                                            {entity.component_name}
                                                          </span>
                                                        </td>
                                                        <td className="found">
                                                          <div
                                                            className={cx(
                                                              'bullet',
                                                              {
                                                                red:
                                                            entity.security_count.top_risk === 'critical',
                                                              },
                                                              {
                                                                orange:
                                                            entity.security_count.top_risk === 'high',
                                                              },
                                                              {
                                                                cheese:
                                                            entity.security_count.top_risk === 'medium',
                                                              },
                                                              {
                                                                yellow:
                                                            entity.security_count.top_risk === 'low',
                                                              }
                                                            )}
                                                          >
                                                            {entity.security_count.total}
                                                          </div>
                                                        </td>
                                                        <td className="found">
                                                          <div
                                                            className={cx(
                                                              'bullet round',
                                                              {
                                                                red: entity.license_count.top_risk === 'protective' && entity.license_count.total !== 0,
                                                              },
                                                              {
                                                                orange: entity.license_count.top_risk === 'permissive' && entity.license_count.total !== 0,
                                                              },
                                                              {
                                                                yellow: entity.license_count.top_risk === 'others' && entity.license_count.total !== 0,
                                                              }
                                                            )}
                                                          >
                                                            {entity.license_count.total}
                                                          </div>
                                                        </td>
                                                        <td
                                                          className="found has_link"
                                                          style={{ fontSize: '10px', padding: '0px' }}
                                                        >
                                                          <span
                                                            onClick={(e) => {
                                                              return this.handleLitigatorDetailModal(
                                                                e,
                                                                entity.litigator_string
                                                              );
                                                            }}
                                                            onKeyUp={(e) => {
                                                              return this.handleLitigatorDetailModal(
                                                                e,
                                                                entity.litigator_string
                                                              );
                                                            }}
                                                          >
                                                            {entity.litigator_string}
                                                          </span>
                                                        </td>
                                                      </tr>
                                                    );
                                                  })
                                                  : null}
                                              </tbody>
                                            </table>
                                          </li>
                                        </ul>
                                      </div>
                                    </td>
                                    <td className="border-none tac">
                                      <a
                                        className="expand_button"
                                      >
                                        <img src={expandBtn} alt="" />
                                      </a>
                                    </td>
                                  </tr>
                                ) : (
                                  <tr
                                    className="first_line"
                                  >
                                    <td
                                      className="border-none tal"
                                      style={{
                                        maxWidth: '120px',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        paddingLeft: '10px',
                                      }}
                                    >
                                      <a
                                        className="export_button"
                                        onClick={() => { return this.handleProjectExport(item); }}
                                        onKeyUp={() => { return this.handleProjectExport(item); }}
                                      >
                                        <img src={exportIcon} style={{ display: 'inline' }} alt="" />
                                      </a>
                                      <a className="bookmark_button" onClick={(e) => { return this.handleProjectBookmarkChange(e, item.pid); }} onKeyUp={(e) => { return this.handleProjectBookmarkChange(e, item.pid); }}>
                                        {
                                          item.isBookmark ? (
                                            <strong className="fake">
                                              <img className="active" role="presentation" src={activeBookmarkImg} alt="" />
                                              {item.projectName}
                                            </strong>
                                          ) : (
                                            <strong className="fake">
                                              <img className="normal" role="presentation" src={normalBookmarkImg} alt="" />
                                              {item.projectName}
                                            </strong>
                                          )
                                        }
                                      </a>
                                    </td>
                                    <td className="tac border-none">{item.versionCount}</td>
                                    <td className="tac border-none">{item.uploadedCount}</td>
                                    <td className="tar border-none tac">
                                      <MiniPieChart chartData={item.componentCount} translate={t} />
                                    </td>
                                    <td className="tac border-none">
                                      <div className="list_wrap">
                                        <ul>
                                          <li className="normal">
                                            <table style={{ tableLayout: 'fixed' }}>
                                              <colgroup>
                                                <col width="" />
                                                <col width="15%" />
                                              </colgroup>
                                              <tbody>
                                                {item.mostFound
                                                  ? item.mostFound.map((entity) => {
                                                    return (
                                                      <tr key={entity.component_name.toString()}>
                                                        <td className="found">
                                                          <span className="name">
                                                            {entity.component_name}
                                                          </span>
                                                        </td>
                                                        <td className="found">{entity.uploaded_file_count}</td>
                                                      </tr>
                                                    );
                                                  })
                                                  : null}
                                              </tbody>
                                            </table>
                                          </li>
                                        </ul>
                                      </div>
                                    </td>
                                    <td className="tac border-none" colSpan="3">
                                      <div className="list_wrap">
                                        <ul>
                                          <li className="normal">
                                            <table style={{ tableLayout: 'fixed' }}>
                                              <colgroup>
                                                <col width="50%" />
                                                <col width="15%" />
                                                <col width="15%" />
                                                <col width="" />
                                              </colgroup>
                                              <tbody>
                                                {item.mostVuln
                                                  ? item.mostVuln.map((entity) => {
                                                    return (
                                                      <tr key={entity.component_name.toString()}>
                                                        <td className="found">
                                                          <span className="name">
                                                            {entity.component_name}
                                                          </span>
                                                        </td>
                                                        <td className="found">
                                                          <div
                                                            className={cx(
                                                              'bullet',
                                                              {
                                                                red:
                                                            entity.security_count.top_risk === 'critical',
                                                              },
                                                              {
                                                                orange:
                                                            entity.security_count.top_risk === 'high',
                                                              },
                                                              {
                                                                cheese:
                                                            entity.security_count.top_risk === 'medium',
                                                              },
                                                              {
                                                                yellow:
                                                            entity.security_count.top_risk === 'low',
                                                              }
                                                            )}
                                                          >
                                                            {entity.security_count.total}
                                                          </div>
                                                        </td>
                                                        <td className="found">
                                                          <div
                                                            className={cx(
                                                              'bullet round',
                                                              {
                                                                red: entity.license_count.top_risk === 'protective' && entity.license_count.total !== 0,
                                                              },
                                                              {
                                                                orange: entity.license_count.top_risk === 'permissive' && entity.license_count.total !== 0,
                                                              },
                                                              {
                                                                yellow: entity.license_count.top_risk === 'others' && entity.license_count.total !== 0,
                                                              }
                                                            )}
                                                          >
                                                            {entity.license_count.total}
                                                          </div>
                                                        </td>
                                                        <td
                                                          className="found has_link"
                                                          style={{ fontSize: '10px', padding: '0px' }}
                                                        >
                                                          <span
                                                            onClick={(e) => {
                                                              return this.handleLitigatorDetailModal(
                                                                e,
                                                                entity.litigator_string
                                                              );
                                                            }}
                                                            onKeyUp={(e) => {
                                                              return this.handleLitigatorDetailModal(
                                                                e,
                                                                entity.litigator_string
                                                              );
                                                            }}
                                                          >
                                                            {entity.litigator_string}
                                                          </span>
                                                        </td>
                                                      </tr>
                                                    );
                                                  })
                                                  : null}
                                              </tbody>
                                            </table>
                                          </li>
                                        </ul>
                                      </div>
                                    </td>
                                    <td className="border-none tac">
                                      <a
                                        className="expand_button"
                                      >
                                        <img src={expandBtn} alt="" />
                                      </a>
                                    </td>
                                  </tr>
                                )
                              }
                              <tr className="second_line extend_item">
                                <td className="border-none tal">&nbsp;</td>
                                <td className="border-none sum_td" colSpan="7">
                                  <Scrollbars
                                    style={{
                                      height: '440px',
                                      overflow: 'hidden',
                                      position: 'relative',
                                    }}
                                    renderTrackHorizontal={() => {
                                      return <div />;
                                    }}
                                    renderThumbHorizontal={() => {
                                      return <div />;
                                    }}
                                  >
                                    {item.upLoaded && item.upLoaded.map((list, i) => {
                                      if (list.project_version_name !== '') {
                                        return (
                                          <table
                                            className={cx(
                                              'wide_card_table wide_card_item list_view project_list_view second_line',
                                              {
                                                more_menu_show: activeMenuIndex === i,
                                              },
                                            )}
                                            key={`${list.uploaded_file_id}_${list.name}`}
                                          >
                                            <colgroup>
                                              <col style={{ width: '6%' }} />
                                              <col style={{ width: '13%', maxWidth: '120px' }} />
                                              <col style={{ width: '8%' }} />
                                              <col style={{ width: '20%' }} />
                                              <col style={{ width: '22%' }} />
                                              <col style={{ width: '4.3%', maxWidth: '40px' }} />
                                              <col style={{ width: '4.3%', maxWidth: '40px' }} />
                                            </colgroup>
                                            <tbody>
                                              <tr
                                                className={cx(
                                                  '',
                                                  {
                                                    version_line: i > 0,
                                                  },
                                                )}
                                              >
                                                <td className="tac border-none">
                                                  <a
                                                    className="version_bookmark_button"
                                                    onClick={() => { return this.toggleVersionBookmarkOnList(index, list.project_version_id); }}
                                                    onKeyUp={() => { return this.toggleVersionBookmarkOnList(index, list.project_version_id); }}
                                                  >
                                                    {
                                                      list.project_version_is_bookmark ? (
                                                        <img src={activeBookmarkImg} alt="" className="active" />
                                                      ) : (
                                                        <img src={normalBookmarkImg} alt="" className="normal" />
                                                      )
                                                    }
                                                  </a>
                                                  {list.project_version_name}
                                                </td>
                                                <td className="tal border-none">
                                                  <Checkbox
                                                    className="select_mode"
                                                    style={{ float: 'left' }}
                                                    value={list.uploaded_file_id}
                                                    checked={checkValues.indexOf(list.uploaded_file_id) > -1}
                                                    onChange={this.handleCheckChange}
                                                    disabled={!list.has_manage_permission}
                                                  />
                                                  <div className="file_name">
                                                    {list.use_scan_option ? (<img src={quickScan} alt="" />) : null}
                                                    {
                                                      list.component_count.total !== 0 ? (
                                                        <span
                                                          className="has_link"
                                                          onClick={() => { return this.handleClick(list.uploaded_file_id); }}
                                                          onKeyUp={() => { return this.handleClick(list.uploaded_file_id); }}
                                                        >
                                                          {list.name}
                                                        </span>
                                                      ) : (
                                                        <span className="none_link">
                                                          {list.name}
                                                        </span>
                                                      )
                                                    }
                                                  </div>
                                                </td>
                                                <td>
                                                  {
                                                    list.component_count.total !== 0 ? (
                                                      <span
                                                        className="has_link"
                                                        onClick={() => { return this.handleChangeView(list.uploaded_file_id, 'component'); }}
                                                        onKeyUp={() => { return this.handleChangeView(list.uploaded_file_id, 'component'); }}
                                                      >
                                                        <MiniPieChart chartData={list.component_count} translate={t} />
                                                      </span>
                                                    ) : (
                                                      <span
                                                        className="none_link"
                                                      >
                                                        <MiniPieChart chartData={list.component_count} translate={t} />
                                                      </span>
                                                    )
                                                  }
                                                </td>
                                                <td className="border-none tac">{list.owner}</td>
                                                <td className="border-none tac">{list.uploaded_at}</td>
                                                <td className="border-none tac">
                                                  {
                                                    this.state.isOpenCompare ? (
                                                      <a
                                                        className="compare_row enable"
                                                        onClick={() => { return this.setCompareItemOnList(list); }}
                                                        onKeyUp={() => { return this.setCompareItemOnList(list); }}
                                                      >
                                                        <img src={compareBtn} alt="" />
                                                      </a>
                                                    ) : (
                                                      <a
                                                        className="compare_row"
                                                        style={{ pointerEvents: 'none', opacity: '.45', color: '#dddddd' }}
                                                      >
                                                        <img src={compareBtn} alt="" />
                                                      </a>
                                                    )
                                                  }
                                                </td>
                                                <td className="border-none tac" style={{ overflow: 'visible' }}>
                                                  <a
                                                    className="more_row"
                                                    onClick={() => { return this.handleMoreMenu(i); }}
                                                    onKeyUp={() => { return this.handleMoreMenu(i); }}
                                                  >
                                                    <img src={moreBtn} alt="more" />
                                                  </a>
                                                  <div className="more_menu">
                                                    <ul>
                                                      <li>
                                                        <a
                                                          onClick={() => { return this.handleInfoItem(list.uploaded_file_id); }}
                                                          onKeyUp={() => { return this.handleInfoItem(list.uploaded_file_id); }}
                                                        >
                                                          <Icon name="info" style={{ color: '#969696' }} />
                                                          {t('card.menu.information')}
                                                        </a>
                                                      </li>
                                                      {
                                                        list.has_leakage ? (
                                                          <li>
                                                            <a
                                                              onClick={() => { return this.handleLeakageList(list.uploaded_file_id, list.name); }}
                                                              onKeyUp={() => { return this.handleLeakageList(list.uploaded_file_id, list.name); }}
                                                            >
                                                              <Icon name="shield" style={{ color: '#969696' }} />
                                                              {t('card.menu.leakage')}
                                                            </a>
                                                          </li>
                                                        ) : null
                                                      }
                                                      <li>
                                                        {
                                                          list.component_count.total > 0 ? (
                                                            <a
                                                              onClick={() => { return this.setCompareItem(list); }}
                                                              onKeyUp={() => { return this.setCompareItem(list); }}
                                                            >
                                                              <img src={compareBtn} alt="" />
                                                              {t('card.menu.compare')}
                                                            </a>
                                                          ) : (
                                                            <a
                                                              style={{
                                                                cursor: 'default',
                                                                opacity: '.45',
                                                                color: '#dddddd',
                                                              }}
                                                            >
                                                              <img src={compareBtn} alt="" />
                                                              {t('card.menu.compare')}
                                                            </a>
                                                          )
                                                        }
                                                      </li>
                                                      <li>
                                                        {this.renderMoveMenu(list)}
                                                      </li>
                                                      <li>
                                                        {
                                                          list.component_count.total === 0 ? (
                                                            <a
                                                              style={{
                                                                cursor: 'default',
                                                                opacity: '.45',
                                                                color: '#dddddd',
                                                              }}
                                                            >
                                                              <Icon name="bookmark outline" style={iconStyle} />
                                                              {t('card.menu.bookmark')}
                                                            </a>
                                                          ) : (
                                                            <a onClick={() => { return this.toggleBookmarkOnList(list.uploaded_file_id, index); }} onKeyUp={() => { return this.toggleBookmarkOnList(list.uploaded_file_id, index); }}>
                                                              {
                                                                list.is_bookmark ? (
                                                                  <Icon name="bookmark" style={iconStyle} />
                                                                ) : (
                                                                  <Icon name="bookmark outline" style={iconStyle} />
                                                                )
                                                              }
                                                              {t('card.menu.bookmark')}
                                                            </a>
                                                          )
                                                        }
                                                      </li>
                                                      {
                                                        state.user.use_crypto ? (
                                                          <li>
                                                            <a
                                                              onClick={() => { return this.handleCBOM(list); }}
                                                              onKeyUp={() => { return this.handleCBOM(list); }}
                                                            >
                                                              <Icon name="download" style={iconStyle} />
                                                              CBOM
                                                            </a>
                                                          </li>
                                                        ) : null
                                                      }
                                                      <li>
                                                        {
                                                          list.component_count.total && list.component_count.total !== 0 ? (
                                                            <a
                                                              className="sbom"
                                                              onClick={this.handleSlideToggle}
                                                              onKeyUp={this.handleSlideToggle}
                                                            >
                                                              <img src={exportIcon} alt="" />
                                                              SBOM
                                                            </a>
                                                          ) : (
                                                            <a
                                                              className="sbom"
                                                              style={{
                                                                cursor: 'default',
                                                                opacity: '.45',
                                                                color: '#dddddd',
                                                              }}
                                                            >
                                                              <img src={exportIcon} alt="" />
                                                              SBOM
                                                            </a>
                                                          )
                                                        }
                                                        <ul
                                                          className={cx(
                                                            'sub_menu',
                                                            {
                                                              active: isShowSbom,
                                                            },
                                                          )}
                                                        >
                                                          <li style={{ padding: '0 0 0 20px' }}>
                                                            <a
                                                              onClick={() => { return this.handleExport(list); }}
                                                              onKeyUp={() => { return this.handleExport(list); }}
                                                            >
                                                              <Icon name="download" style={iconStyle} />
                                                              {t('card.menu.clarity')}
                                                            </a>
                                                          </li>
                                                          <li style={{ padding: '0 0 0 20px' }}>
                                                            <a
                                                              onClick={() => { return this.handleSpdx(list.uploaded_file_id, list.name); }}
                                                              onKeyUp={() => { return this.handleSpdx(list.uploaded_file_id, list.name); }}
                                                            >
                                                              <Icon name="download" style={iconStyle} />
                                                              {t('card.menu.spdx')}
                                                            </a>
                                                          </li>
                                                          <li style={{ padding: '0 0 0 20px' }}>
                                                            <a
                                                              onClick={() => { return this.handleCycloneDx(list.uploaded_file_id); }}
                                                              onKeyUp={() => { return this.handleCycloneDx(list.uploaded_file_id); }}
                                                            >
                                                              <Icon name="download" style={iconStyle} />
                                                              CycloneDX
                                                            </a>
                                                          </li>
                                                          <li style={{ padding: '0 0 0 20px' }}>
                                                            <a
                                                              onClick={() => { return this.handleVexBom(list.uploaded_file_id); }}
                                                              onKeyUp={() => { return this.handleVexBom(list.uploaded_file_id); }}
                                                            >
                                                              <Icon name="download" style={iconStyle} />
                                                              VEX
                                                            </a>
                                                          </li>
                                                          <li style={{ padding: '0 0 0 20px' }}>
                                                            <a
                                                              onClick={() => { return this.handleNIASbom(list.uploaded_file_id); }}
                                                              onKeyUp={() => { return this.handleNIASbom(list.uploaded_file_id); }}
                                                            >
                                                              <Icon name="download" style={iconStyle} />
                                                              NIS
                                                            </a>
                                                          </li>
                                                        </ul>
                                                      </li>
                                                      <li>
                                                        {list.has_manage_permission ? (
                                                          <a
                                                            onClick={() => { return this.handleDeleteOnList(list); }}
                                                            onKeyUp={() => { return this.handleDeleteOnList(list); }}
                                                          >
                                                            <img src={deleteIcon} alt="" />
                                                            {t('card.menu.delete')}
                                                          </a>
                                                        ) : (
                                                          <a
                                                            style={{
                                                              cursor: 'default',
                                                              opacity: '.45',
                                                              color: '#dddddd',
                                                            }}
                                                          >
                                                            <img src={deleteIcon} alt="" />
                                                            {t('card.menu.delete')}
                                                          </a>
                                                        )}
                                                      </li>
                                                    </ul>
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        );
                                      }
                                      return (
                                        <table
                                          className={cx(
                                            'wide_card_table wide_card_item project_list_view second_line',
                                            {
                                              more_menu_show: activeMenuIndex === i,
                                            },
                                          )}
                                          key={`${list.uploaded_file_id}_${list.name}`}
                                        >
                                          <colgroup>
                                            <col style={{ width: '6%' }} />
                                            <col style={{ width: '13%', maxWidth: '120px' }} />
                                            <col style={{ width: '8%' }} />
                                            <col style={{ width: '20%' }} />
                                            <col style={{ width: '22%' }} />
                                            <col style={{ width: '4.3%', maxWidth: '40px' }} />
                                            <col style={{ width: '4.3%', maxWidth: '40px' }} />
                                          </colgroup>
                                          <tbody>
                                            <tr className="">
                                              <td className="tac border-none">&nbsp;</td>
                                              <td className="tal border-none">
                                                <Checkbox
                                                  className="select_mode"
                                                  style={{ float: 'left' }}
                                                  value={list.uploaded_file_id}
                                                  checked={checkValues.indexOf(list.uploaded_file_id) > -1}
                                                  onChange={this.handleCheckChange}
                                                  disabled={!list.has_manage_permission}
                                                />
                                                <div className="file_name">
                                                  {list.use_scan_option ? (<img src={quickScan} alt="" />) : null}
                                                  {
                                                    list.component_count.total !== 0 ? (
                                                      <span
                                                        className="has_link"
                                                        onClick={() => { return this.handleClick(list.uploaded_file_id); }}
                                                        onKeyUp={() => { return this.handleClick(list.uploaded_file_id); }}
                                                      >
                                                        {list.name}
                                                      </span>
                                                    ) : (
                                                      <span className="none_link">
                                                        {list.name}
                                                      </span>
                                                    )
                                                  }
                                                </div>
                                              </td>
                                              <td>
                                                {
                                                  list.component_count.total !== 0 ? (
                                                    <span
                                                      className="has_link"
                                                      onClick={() => { return this.handleChangeView(list.uploaded_file_id, 'component'); }}
                                                      onKeyUp={() => { return this.handleChangeView(list.uploaded_file_id, 'component'); }}
                                                    >
                                                      <MiniPieChart chartData={list.component_count} translate={t} />
                                                    </span>
                                                  ) : (
                                                    <span
                                                      className="none_link"
                                                    >
                                                      <MiniPieChart chartData={list.component_count} translate={t} />
                                                    </span>
                                                  )
                                                }
                                              </td>
                                              <td className="border-none tac">{list.owner}</td>
                                              <td className="border-none tac">{list.uploaded_at}</td>
                                              <td className="border-none tac">
                                                {
                                                  this.state.isOpenCompare ? (
                                                    <a
                                                      className="compare_row enable"
                                                      onClick={() => { return this.setCompareItemOnList(list); }}
                                                      onKeyUp={() => { return this.setCompareItemOnList(list); }}
                                                    >
                                                      <img src={compareBtn} alt="" />
                                                    </a>
                                                  ) : (
                                                    <a
                                                      className="compare_row"
                                                      style={{ pointerEvents: 'none', opacity: '.45', color: '#dddddd' }}
                                                    >
                                                      <img src={compareBtn} alt="" />
                                                    </a>
                                                  )
                                                }
                                              </td>
                                              <td className="border-none tac" style={{ overflow: 'visible' }}>
                                                <a
                                                  className="more_row"
                                                  onClick={() => { return this.handleMoreMenu(i); }}
                                                  onKeyUp={() => { return this.handleMoreMenu(i); }}
                                                >
                                                  <img src={moreBtn} alt="more" />
                                                </a>
                                                <div className="more_menu">
                                                  <ul>
                                                    <li>
                                                      <a
                                                        onClick={() => { return this.handleInfoItem(list.uploaded_file_id); }}
                                                        onKeyUp={() => { return this.handleInfoItem(list.uploaded_file_id); }}
                                                      >
                                                        <Icon name="info" style={{ color: '#969696' }} />
                                                        {t('card.menu.information')}
                                                      </a>
                                                    </li>
                                                    {
                                                      list.has_leakage ? (
                                                        <li>
                                                          <a
                                                            onClick={() => { return this.handleLeakageList(list.uploaded_file_id, list.name); }}
                                                            onKeyUp={() => { return this.handleLeakageList(list.uploaded_file_id, list.name); }}
                                                          >
                                                            <Icon name="shield" style={{ color: '#969696' }} />
                                                            {t('card.menu.leakage')}
                                                          </a>
                                                        </li>
                                                      ) : null
                                                    }
                                                    <li>
                                                      {
                                                        list.component_count.total > 0 ? (
                                                          <a
                                                            onClick={() => { return this.setCompareItem(list); }}
                                                            onKeyUp={() => { return this.setCompareItem(list); }}
                                                          >
                                                            <img src={compareBtn} alt="" />
                                                            {t('card.menu.compare')}
                                                          </a>
                                                        ) : (
                                                          <a
                                                            style={{
                                                              cursor: 'default',
                                                              opacity: '.45',
                                                              color: '#dddddd',
                                                            }}
                                                          >
                                                            <img src={compareBtn} alt="" />
                                                            {t('card.menu.compare')}
                                                          </a>
                                                        )
                                                      }
                                                    </li>
                                                    <li>
                                                      {this.renderMoveMenu(list)}
                                                    </li>
                                                    <li>
                                                      {
                                                        list.component_count.total === 0 ? (
                                                          <a
                                                            style={{
                                                              cursor: 'default',
                                                              opacity: '.45',
                                                              color: '#dddddd',
                                                            }}
                                                          >
                                                            <Icon name="bookmark outline" style={iconStyle} />
                                                            {t('card.menu.bookmark')}
                                                          </a>
                                                        ) : (
                                                          <a onClick={() => { return this.toggleBookmarkOnList(list.uploaded_file_id, index); }} onKeyUp={() => { return this.toggleBookmarkOnList(list.uploaded_file_id, index); }}>
                                                            {
                                                              list.is_bookmark ? (
                                                                <Icon name="bookmark" style={iconStyle} />
                                                              ) : (
                                                                <Icon name="bookmark outline" style={iconStyle} />
                                                              )
                                                            }
                                                            {t('card.menu.bookmark')}
                                                          </a>
                                                        )
                                                      }
                                                    </li>
                                                    {
                                                      state.user.use_crypto ? (
                                                        <li>
                                                          <a
                                                            onClick={() => { return this.handleCBOM(list); }}
                                                            onKeyUp={() => { return this.handleCBOM(list); }}
                                                          >
                                                            <Icon name="download" style={iconStyle} />
                                                            CBOM
                                                          </a>
                                                        </li>
                                                      ) : null
                                                    }
                                                    <li>
                                                      {
                                                        list.component_count.total && list.component_count.total !== 0 ? (
                                                          <a
                                                            className="sbom"
                                                            onClick={this.handleSlideToggle}
                                                            onKeyUp={this.handleSlideToggle}
                                                          >
                                                            <img src={exportIcon} alt="" />
                                                            SBOM
                                                          </a>
                                                        ) : (
                                                          <a
                                                            className="sbom"
                                                            style={{
                                                              cursor: 'default',
                                                              opacity: '.45',
                                                              color: '#dddddd',
                                                            }}
                                                          >
                                                            <img src={exportIcon} alt="" />
                                                            SBOM
                                                          </a>
                                                        )
                                                      }
                                                      <ul
                                                        className={cx(
                                                          'sub_menu',
                                                          {
                                                            active: isShowSbom,
                                                          },
                                                        )}
                                                      >
                                                        <li style={{ padding: '0 0 0 20px' }}>
                                                          <a
                                                            onClick={() => { return this.handleExport(list); }}
                                                            onKeyUp={() => { return this.handleExport(list); }}
                                                          >
                                                            <Icon name="download" style={iconStyle} />
                                                            {t('card.menu.clarity')}
                                                          </a>
                                                        </li>
                                                        <li style={{ padding: '0 0 0 20px' }}>
                                                          <a
                                                            onClick={() => { return this.handleSpdx(list.uploaded_file_id, list.name); }}
                                                            onKeyUp={() => { return this.handleSpdx(list.uploaded_file_id, list.name); }}
                                                          >
                                                            <Icon name="download" style={iconStyle} />
                                                            {t('card.menu.spdx')}
                                                          </a>
                                                        </li>
                                                        <li style={{ padding: '0 0 0 20px' }}>
                                                          <a
                                                            onClick={() => { return this.handleCycloneDx(list.uploaded_file_id); }}
                                                            onKeyUp={() => { return this.handleCycloneDx(list.uploaded_file_id); }}
                                                          >
                                                            <Icon name="download" style={iconStyle} />
                                                            CycloneDX
                                                          </a>
                                                        </li>
                                                        <li style={{ padding: '0 0 0 20px' }}>
                                                          <a
                                                            onClick={() => { return this.handleNIASbom(list.uploaded_file_id); }}
                                                            onKeyUp={() => { return this.handleNIASbom(list.uploaded_file_id); }}
                                                          >
                                                            <Icon name="download" style={iconStyle} />
                                                            NIS
                                                          </a>
                                                        </li>
                                                      </ul>
                                                    </li>
                                                    <li>
                                                      {list.has_manage_permission ? (
                                                        <a
                                                          onClick={() => { return this.handleDeleteOnList(list); }}
                                                          onKeyUp={() => { return this.handleDeleteOnList(list); }}
                                                        >
                                                          <img src={deleteIcon} alt="" />
                                                          {t('card.menu.delete')}
                                                        </a>
                                                      ) : (
                                                        <a
                                                          style={{
                                                            cursor: 'default',
                                                            opacity: '.45',
                                                            color: '#dddddd',
                                                          }}
                                                        >
                                                          <img src={deleteIcon} alt="" />
                                                          {t('card.menu.delete')}
                                                        </a>
                                                      )}
                                                    </li>
                                                  </ul>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      );
                                    })}
                                    {item.isNextData && <div style={{ textAlign: 'center' }}>{this.renderMoreBtn(item.pid)}</div>}
                                  </Scrollbars>
                                </td>
                                <td className="border-none tal">&nbsp;</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      );
                    })}
                    {error && <div className="error_log">{error}</div>}
                    <div style={{ paddingBottom: '14px' }}>
                      <Loader active={isLoading} inline="centered" />
                    </div>
                    {
                      projectList.length !== 0
                    && (
                      <div className="clar_pagination" style={{ marginTop: '10px', textAlign: 'center' }}>
                        <Pagination
                          activePage={currentPage}
                          totalPages={totalPage}
                          onPageChange={this.handlePaginationChange}
                          //size="mini"
                          ellipsisItem={{ content: <Icon name="ellipsis horizontal" />, icon: true }}
                          firstItem={currentPage !== 1 ? { content: <Icon name="angle double left" />, icon: true } : null}
                          lastItem={currentPage !== totalPage ? { content: <Icon name="angle double right" />, icon: true } : null}
                          prevItem={currentPage > 1 ? { content: <Icon name="angle left" />, icon: true } : null}
                          nextItem={currentPage < totalPage ? { content: <Icon name="angle right" />, icon: true } : null}
                        />
                        <div className="active_page">
                          <Input
                            type="number"
                            label={t('list.title.active_page')}
                            min={1}
                            value={activePage}
                            onChange={this.handleInputActivePageChange}
                            onKeyPress={this.handleActivePageChange}
                          />
                        </div>
                      </div>
                    )
                    }
                    {!hasMoreProjectList && <Footer />}
                  </div>
                </div>
              </div>
            )
          }

          <CompareModal
            isOpenCPM={this.state.isOpenCPM}
            isCompareLoading={this.state.isCompareLoading}
            closeModal={this.handleCPMClose}
            compareResult={this.state.compareResult}
            translate={t}
          />
          <LeakageListModal
            isOpenMLK={this.state.isOpenMLK}
            uploadedFileId={this.state.selectedUid}
            fileName={this.state.selectedName}
            closeModal={this.handleMLKClose}
            translate={t}
          />
          <ScanInfoModal
            isOpenMSI={this.state.isOpenMSI}
            reportId={scanInfoUid}
            closeModal={this.handleMSIClose}
            translate={t}
          />
          <ExportModal
            isOpenMED={this.state.modalExportIsOpen}
            onClose={this.closeExportModal}
            handleModal={this.downloadReport}
            isDownloading={this.state.isDownloadingReport}
            birdView
            rowData={this.state.currentData}
            translate={t}
          />
          <MoveFileModal
            isOpenMFM={this.state.isOpenMFM}
            closeModal={this.closeMoveFileModal}
            rowData={this.state.currentData}
            isMovingFile={this.state.isMovingFile}
            setFileMove={this.setFileMove}
            translate={t}
          />
          <DeleteModal
            isOpen={this.state.isOpenAlert}
            isSelectable={this.state.isSelectable}
            checkValues={this.state.checkValues}
            rowData={this.state.currentData}
            closeModal={this.closeModal}
            deletedCallback={this.deletedCallback}
            handleMultipleDeleteCallback={this.handleMultipleDeleteCallback}
            translate={t}
          />
          <WarningModal
            isOpenWarnModal={isOpenWarnModal}
            mainText={mainText}
            subText={subText}
            closeModal={this.closeModal}
            translate={t}
          />
          <ProjectExportModal
            isOpenMPE={isOpenMPE}
            onClose={this.closeExportModal}
            handleModal={this.downloadProjectReport}
            initLoading={this.initLoading}
            isDownloading={isDownloadingProjectReport}
            isLoading={isLoadingProjectReport}
            birdView
            projectName={selectedProjectName}
            projectId={selectedProjectId}
            translate={t}
          />
          <SPDXDocumentGenerator
            isOpenMCX={isOpenMCX}
            reportId={reportId}
            uploadedFileName={uploadedFileName}
            closeModal={this.closeModal}
            translate={t}
          />
          <CycloneDXDocumentGenerator
            isOpenMCD={isOpenMCD}
            reportId={reportId}
            closeModal={this.closeModal}
            translate={t}
          />
          <VexGenerator
            isOpenMVX={isOpenMVX}
            reportId={reportId}
            closeModal={this.closeModal}
            translate={t}
          />
          <CBOMGenerator
            isOpenMCB={isOpenMCB}
            reportId={reportId}
            fileName={uploadedFileName}
            closeModal={this.closeModal}
            translate={t}
          />
          <NISModal
            isOpenMNA={isOpenMNA}
            reportId={reportId}
            translate={t}
            closeModal={this.closeModal}
          />
          <Modal open={isOpenAlertModal} onClose={this.closeModal}>
            <div className="modal_popup_wrap confirm_wrap">
              <div className="modal_popup_box confirm_box">
                <div
                  className={cx(
                    'modal_popup confirm',
                    {
                      'error-message': isModalError,
                    },
                  )}
                >
                  <h2 className="title">{this.modalAction}</h2>
                  {
                    toExport === 's3' ? (
                      <Modal.Description>
                        <Header>
                          {this.modalBody}
                        </Header>
                        {this.modalHeader}
                        {this.modalSubBody}
                      </Modal.Description>
                    ) : (
                      <Modal.Description>
                        <Header>
                          {this.modalBody}
                        </Header>
                        <p className="modal_list">{this.modalHeader}</p>
                        <p>{this.modalSubBody}</p>
                      </Modal.Description>
                    )
                  }

                  <div className="button_wrap">
                    <a className="center_button" onClick={this.closeModal} onKeyUp={this.closeModal}>
                      {t('modal.button.ok')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </DragDropContext>
      </div>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(ComponentProjectList))));
